/* global myAjax */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/filepond-plugin-media-preview.min.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
//import ScrollOut from 'scroll-out';
import AOS from 'aos';
import 'isotope-packery';
import Isotope from 'isotope-layout';
import 'packery/dist/packery.pkgd.min';
import Draggabilly from 'draggabilly';
import 'select2';
// ES6 Modules or TypeScript
import Swal from 'sweetalert2';
import { empty } from 'ramda';
// import { empty } from 'ramda';
/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function menuNavigation() {
  $('.header-icon').on('click', function() {
    let anchorID = $(this).attr('data-anchor'),
      scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    $('.header-icons').css('right', scrollbarWidth);

    $('.header-item-js').hide();
    $(anchorID).show();

    if (!$('#header').hasClass('active') || $(this).hasClass('active')) {
      $('body').toggleClass('menu-open');
      $('#header').toggleClass('active');
      $('#header-icons').toggleClass('active');
      $(this).toggleClass('active');
      return;
    }

    $('.header-icon.active').removeClass('active');
    $(this).addClass('active');
  });
}

function stikyPricingHeader() {
  if ($('#pricing-header').length && window.innerWidth > 1024) {
    let $header = $('#pricing-header');
    let scrollToStick =
      $('#pricing-header-anchor').offset().top - $header.outerHeight();

    document.onscroll = () => {
      if ($(window).scrollTop() >= scrollToStick) {
        if (!$header.hasClass('sticky')) {
          $header.addClass('sticky');
        }
      } else {
        $header.removeClass('sticky');
      }
    };
  }
}

function profileTour(dataAction) {
  let $firstAccItem = $('#member-accordion .accordion-item').first();

  if (dataAction) {
    $('.profile-tour').fadeOut();
    $(`#${dataAction}`).fadeIn();

    setTimeout(function() {
      $('html, body').animate(
        {
          scrollTop:
            $(`#${dataAction}`).offset().top -
            (window.innerHeight / 2 - $(`#${dataAction}`).outerHeight() / 2),
        },
        600
      );
    }, 300);
  }

  switch (dataAction) {
    case 'step-sidebar':
      $('.member-sidebar').addClass('is-tour');
      break;
    case 'step-avatar':
      $('.member-sidebar').removeClass('is-tour');
      $firstAccItem.find('.accordion-title').removeClass('is-tour');
      $('#member-accordion').foundation(
        'up',
        $firstAccItem.find('.accordion-content')
      );
      break;
    case 'step-expanders':
      $firstAccItem.find('.accordion-title').addClass('is-tour');
      $('#member-accordion').foundation(
        'down',
        $firstAccItem.find('.accordion-content')
      );
      break;
    case 'step-store':
      $firstAccItem.find('.accordion-title').removeClass('is-tour');
      $('#member-accordion').foundation(
        'up',
        $firstAccItem.find('.accordion-content')
      );
      setTimeout(function() {
        $(`#${dataAction}`)
          .closest('.tabs-title')
          .click();
      }, 10);
      break;
    case 'step-portfolio':
      setTimeout(function() {
        $(`#${dataAction}`)
          .closest('.tabs-title')
          .click();
      }, 10);
      break;
    case 'step-content':
      setTimeout(function() {
        $(`#${dataAction}`)
          .closest('.tabs-title')
          .click();
      }, 10);
      break;
    case 'step-network':
      setTimeout(function() {
        $(`#${dataAction}`)
          .closest('.tabs-title')
          .click();
      }, 10);
      break;
    case 'step-inspiration':
      setTimeout(function() {
        $(`#${dataAction}`)
          .closest('.tabs-title')
          .click();
      }, 10);
      $('#header').removeClass('is-tour');
      $('#header-icons .active')
        .removeClass('is-tour')
        .click();
      break;
    case 'step-navbar':
      $('#header').addClass('is-tour');
      $('#header-icons .header-icon--person')
        .addClass('is-tour')
        .click();
      break;
    case 'tour-ended':
      $('#header').removeClass('is-tour');
      $('#header-icons .active')
        .removeClass('is-tour')
        .click();
      $('#member-tabs .tabs-title')
        .first()
        .click();
      break;
  }
}

$('#togBtn').on('change', function() {
  var showSubscr = $(this).is(':checked');
  $('#product_amount').toggleClass('show', showSubscr);
  $('.add-product-subscription .select2').toggleClass('show', showSubscr);
});

//
// (function(window, factory) {
//   if (typeof define === 'function' && define.amd) {
//     // AMD
//     define(['isotope-layout/js/layout-mode'], factory);
//   } else if (typeof exports === 'object') {
//     // CommonJS
//     module.exports = factory(require('isotope-layout/js/layout-mode'));
//   } else {
//     // browser global
//     factory(window.Isotope.LayoutMode);
//   }
// })(window, function factory(LayoutMode) {
//   'use strict';
//
//   var FitColumns = LayoutMode.create('fitColumns');
//   var proto = FitColumns.prototype;
//
//   proto._resetLayout = function() {
//     this.x = 0;
//     this.y = 0;
//     this.maxX = 0;
//   };
//
//   proto._getItemLayoutPosition = function(item) {
//     item.getSize();
//
//     // if this element cannot fit in the current row
//     if (
//       this.y !== 0 &&
//       item.size.outerHeight + this.y > this.isotope.size.innerHeight
//     ) {
//       this.y = 0;
//       this.x = this.maxX;
//     }
//
//     var position = {
//       x: this.x,
//       y: this.y,
//     };
//
//     this.maxX = Math.max(this.maxX, this.x + item.size.outerWidth);
//     this.y += item.size.outerHeight;
//
//     return position;
//   };
//
//   proto._getContainerSize = function() {
//     return { width: this.maxX };
//   };
//
//   proto.needsResizeLayout = function() {
//     return this.needsVerticalResizeLayout();
//   };
//
//   return FitColumns;
// });

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  $(document)
    .find('.nwk__item')
    .each(function() {
      var width = $(this).width();
      $(this).height(width);
    });

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  // Add fancybox to images
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');
  $(
    'a[rel*="album"], .fancybox, a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  ).fancybox({
    minHeight: 0,
    smallBtn: false,
    helpers: {
      overlay: {
        locked: false,
      },
    },
    buttons: ['zoom', 'download', 'thumbs', 'close'],
  });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   threshold: 0.3,
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on('change keyup', '.gfield input, .gfield textarea', function() {
    let $field = $(this).closest('.gfield');
    if ($field.hasClass('gfield_error') && $(this).val().length) {
      $field.find('.validation_message').hide();
    } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
      $field.find('.validation_message').show();
    }
  });

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function() {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });
  $('.js-example-basic-multiple').select2({
    placeholder: 'Professions',
    tags: true,
  });
  //Case studies start
  $('.case-studies-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 0,
    prevArrow: jQuery('.case-studies-prev'),
    nextArrow: jQuery('.case-studies-next'),
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  function caseStudiesResize(){
    if ($(window).width() > 1024) {
      $('.studies-item').css('height', $('.case-studies').height());
    }
  }
  caseStudiesResize();
  $(window).resize(function() {
    caseStudiesResize();
  });
  //Case studies end
  $('.testimonials-slider').on('init reInit afterChange', function(
    event,
    slick,
    currentSlide
  ) {
    let i = (currentSlide ? currentSlide : 0) + 1;
    $('.paging-info').text(i + ' of ' + slick.slideCount);
  });

  $('.testimonials-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 0,
    prevArrow: jQuery('.testimonials-prev'),
    nextArrow: jQuery('.testimonials-next'),
  });

  $('.articles-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 7000,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 0,
    prevArrow: jQuery('.articles-prev'),
    nextArrow: jQuery('.articles-next'),
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#compare-slider-left').slick({
    dots: false,
    arrows: true,
    nextArrow: $('.compare-content__wrapper-next'),
    prevArrow: $('.compare-content__wrapper-prev'),
    slidesToScroll: 1,
    slidesToShow: 2,
    // fade: true,
    asNavFor: '#compare-slider-right',
    // row: 0,
    infinite: false,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#compare-slider-right').slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 2,
    // fade: true,
    asNavFor: '#compare-slider-left',
    // row: 0,
    infinite: false,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#hire-time').change(function() {
    $('.hire-slider-wrap').show();
    let hirePrice = $(this).val(),
      hireLabel = $(this)
        .find(':selected')
        .data('label'),
      sliderMax = 120,
      sliderLbl = 'hrs',
      sliderValues = [20, 50],
      $hireSlider = $('#hire-slider');

    switch (hireLabel) {
      case 'days':
        sliderMax = 90;
        sliderLbl = 'd';
        sliderValues = [20, 40];
        break;
      case 'weeks':
        sliderMax = 52;
        sliderLbl = 'w';
        sliderValues = [12, 24];
        break;
      case 'months':
        sliderMax = 36;
        sliderLbl = 'm';
        sliderValues = [8, 16];
        break;
      default:
        sliderMax = 120;
        sliderLbl = 'hrs';
        sliderValues = [20, 50];
    }

    $('.cost-estimate__min').html('$' + sliderValues[0] * hirePrice);
    $('.cost-estimate__max').html('$' + sliderValues[1] * hirePrice);

    $('.hire-label').html(hireLabel);

    if ($hireSlider.hasClass('ui-slider')) {
      $hireSlider.slider('destroy');
    }
    $hireSlider.slider({
      range: true,
      min: 1,
      max: sliderMax,
      values: sliderValues,
      slide: function(event, ui) {
        console.log('lol');
        $('.price-range-min').html(ui.values[0] + ' ' + sliderLbl);
        $('.price-range-max').html(ui.values[1] + ' ' + sliderLbl);
        $('.cost-estimate__min').html('$' + ui.values[0] * hirePrice);
        $('.cost-estimate__max').html('$' + ui.values[1] * hirePrice);
        //

        if (ui.values[0] == ui.values[1]) {
          $('.price-range-both i').css('display', 'none');
        } else {
          $('.price-range-both i').css('display', 'inline');
        }

        //

        if (collision($('.price-range-min'), $('.price-range-max')) == true) {
          $('.price-range-min, .price-range-max').css('opacity', '0');
          $('.price-range-both').css('display', 'block');
        } else {
          $('.price-range-min, .price-range-max').css('opacity', '1');
          $('.price-range-both').css('display', 'none');
        }
      },
    });

    // $('.ui-slider-range').append(
    //   '<span class="price-range-both value"><i>$' +
    //     $('#hire-slider').slider('values', 0) +
    //     ' - </i>' +
    //     $('#hire-slider').slider('values', 1) +
    //     '</span>'
    // );

    $('.hire-slider .ui-slider-handle:eq(0)').html(
      '<span class="price-range-min value">' +
        $('#hire-slider').slider('values', 0) +
        ' ' +
        sliderLbl +
        '</span>'
    );

    $('.hire-slider .ui-slider-handle:eq(1)').html(
      '<span class="price-range-max value">' +
        $('#hire-slider').slider('values', 1) +
        ' ' +
        sliderLbl +
        '</span>'
    );

    function collision($div1, $div2) {
      var x1 = $div1.offset().left;
      var w1 = $div1.outerWidth();
      var r1 = x1 + w1;
      var x2 = $div2.offset().left;
      var w2 = $div2.outerWidth();
      var r2 = x2 + w2;

      if (r1 < x2 || x1 > r2) return false;
      return true;
    }
  });

  $('.hire-tabs-switcher').on('click', function(e) {
    e.preventDefault();
    var modal_id = $(this).attr('href');
    $('.popup-tabs').fadeOut();
    $(modal_id).fadeIn();
    // $('.my-rates__min').html()

    alignCloseBtn ();
    //setTimeout(alignCloseBtn, 500);
  });

  $('#wrapper-mobile-slider').slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
  });

  var singleProductSlider = $(
    '.single-product .woocommerce-product-gallery .flex-control-nav'
  );
  singleProductSlider.on('afterChange', function(event, slick, currentSlide) {
    var CurrentSlideDom = $(slick.$slides.get(currentSlide));
    CurrentSlideDom.trigger('click');
    $(
      '.single-product .woocommerce-product-gallery .flex-control-nav .slick-current'
    ).trigger('click');
  });

  $('.single-product .woocommerce-product-gallery .flex-control-nav').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: false,
        },
      },
    ],
  });

  $('#member-work-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 0,
    prevArrow: $('#member-work-arrows .slick-prev'),
    nextArrow: $('#member-work-arrows .slick-next'),
  });

  $('#accordion-member-work .accordion-title').on('click', function() {
    $('#member-work-slider').slick('resize');
  });

  $('#member-skills-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 0,
    prevArrow: $('#member-skills-arrows .slick-prev'),
    nextArrow: $('#member-skills-arrows .slick-next'),
  });

  $('#accordion-member-skills .accordion-title').on('click', function() {
    $('#member-skills-slider').slick('resize');
  });

  $('#banner-slider').on('init reInit afterChange', function(
    event,
    slick,
    currentSlide
  ) {
    let i = (currentSlide ? currentSlide : 0) + 1;
    $('.paging-info').text(i + ' of ' + slick.slideCount);
  });

  $('#banner-slider').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 0,
    prevArrow: $('.banner-slider-prev'),
    nextArrow: $('.banner-slider-next'),
  });

  (function() {
    let membersColumnWidth;
    updateColumnWidth();
    let containerWidth;
    updateContainerWidth();
    let offsetScroll = membersColumnWidth * 2;
    let currPos = membersColumnWidth * 17;

    $('.hero-members-scroll').animate({ scrollLeft: currPos }, 100);

    $(window).on('load', function() {
      setTimeout(slideHeroMembers, 1000);
    });

    $('.hero-members-wrap')
      .addClass('sliding')
      .mouseenter(function() {
        $(this).removeClass('sliding');
      })
      .mouseleave(function() {
        $(this).addClass('sliding');
        slideHeroMembers();
      });

    function slideHeroMembers() {
      if (
        currPos + innerWidth < $('#hero-members').outerWidth() &&
        $('.hero-members-wrap').hasClass('sliding')
      ) {
        $('.hero-members-scroll').animate(
          {
            scrollLeft: (currPos += 25),
          },
          500,
          'linear',
          slideHeroMembers
        );
      }
    }

    //$('.hero-members-scroll').scrollLeft(currPos);

    $('.hero-members__right').on('click', () => {
      if (currPos + innerWidth < $('#hero-members').outerWidth()) {
        $('.hero-members-scroll').animate({
          scrollLeft: (currPos += offsetScroll),
        });
      }

      if (
        currPos + innerWidth + offsetScroll >=
        $('#hero-members').outerWidth()
      ) {
        // loadMembers();
      }
    });

    $('.hero-members__left').on('click', () => {
      if (currPos > 0) {
        $('.hero-members-scroll').animate({
          scrollLeft: (currPos -= offsetScroll),
        });
      }

      if (currPos - offsetScroll < 0) {
        // loadMembers(true);
      }
    });

    function updateColumnWidth() {
      var wWidth = $(window).width(); // use this instead of innerWidth to make sure that scroolbar was included to our calculation
      if (innerWidth < 380) {
        membersColumnWidth = wWidth / 2;
      } else if (innerWidth < 640) {
        membersColumnWidth = wWidth / 3;
      } else if (innerWidth < 1440) {
        membersColumnWidth = wWidth / 10;
      } else {
        membersColumnWidth = wWidth / 12;
      }
      membersColumnWidth = membersColumnWidth + 6;
      $('.members-column').css({ width: membersColumnWidth });
    }

    //console.log(outerWidth);

    function updateContainerWidth() {
      containerWidth =
        $('#hero-members').find('.members-column').length * membersColumnWidth;
      $('#hero-members').css({ width: containerWidth });
    }

    function loadMembers(prepend = false) {
      let $insertHtml = $('#hero-members');

      if (!$insertHtml.hasClass('loading')) {
        $insertHtml.addClass('loading');
        let data = {
          action: 'hero_member_items',
        };
        $.ajax({
          url: myAjax.url,
          data: data,
          type: 'POST',
          success: function(res) {
            if (res.html) {
              // prepend
              //   ? $insertHtml.prepend(res.html)
              //   : $insertHtml.append(res.html);
              $insertHtml.prepend(res.html);
              $insertHtml.append(res.html);
              updateColumnWidth();
              updateContainerWidth();
              if (prepend) {
                $('.hero-members-scroll').scrollLeft((currPos += offsetScroll));
              }
            } else {
              console.log('res.html is empty.');
            }
            $insertHtml.removeClass('loading');
          },
          error: function(xhr, textStatus, error) {
            console.log(xhr.statusText);
            console.log(textStatus);
            console.log(error);
          },
        });
      }
    }

    loadMembers(true);
    // $(window).on('resize', function() {
    //   updateColumnWidth();
    //   updateContainerWidth();
    // });
  })();

  $('.cart-item__plus').on('click', function() {
    var val = parseInt(
      $(this)
        .parent()
        .find('.input-text')
        .val()
    );

    $(this)
      .parent()
      .find('.input-text')
      .val(val + 1);

    $('.cart-item__quantity .input-text').trigger('change');
  });
  $('.cart-item__minus').on('click', function() {
    var val = parseInt(
      $(this)
        .parent()
        .find('.input-text')
        .val()
    );

    if (val > 1) {
      $(this)
        .parent()
        .find('.input-text')
        .val(val - 1);
    }
    $('.cart-item__quantity .input-text').trigger('change');
  });

  $(document).on('change', 'input.qty', function() {
    var item_key = $(this).data('key');
    var item_quantity = $(this).val();
    var currentVal = parseFloat(item_quantity);

    function qty_cart() {
      $.ajax({
        type: 'POST',
        url: myAjax.url,
        data: {
          action: 'qty_cart',
          key: item_key,
          quantity: currentVal,
        },
        success: function(data) {
          $(document.body).trigger('wc_fragment_refresh');
          console.log(data);
          $('.cart-total__counter').html(data);
        },
      });
    }

    qty_cart();
  });

  $('.hero-members__search').on('click', function() {
    $('.members-search-wrap').toggleClass('active');
  });

  $('.billing-wrap').on('click', '.billing-switch', function() {
    let $billingWrap = $(this).closest('.billing-wrap');
    if ($(this).prop('checked') == true) {
      $billingWrap.find('.billing-monthly').hide();
      $billingWrap.find('.billing-annual').fadeIn();
    } else if ($(this).prop('checked') == false) {
      $billingWrap.find('.billing-annual').hide();
      $billingWrap.find('.billing-monthly').fadeIn();
    }
  });

  $('#pricing-header').on('click', '.pricing-header__item a', function(e) {
    e.preventDefault();
    $('#pricing-tabs').foundation('selectTab', $(this).attr('href'));
    $('html, body').animate({ scrollTop: 0 }, 600);
  });

  $('.scrollToTop').on('click', function() {
    $('html, body').animate({ scrollTop: 0 }, 600);
  });

  $('.cart-item__remove').on('click', function() {
    let $this = $(this);
    $.ajax({
      url: myAjax.url,
      data: {
        action: 'remove_item_from_cart',
        product_id: $this.attr('data-product-id'),
      },
      type: 'POST',
      success: function(res) {
        if (res) {
          $this.closest('.cart-item').remove();
          $('.cart-checkout .cart-total span')
            .remove('.woocommerce-Price-amount')
            .prepend(res.cartTotal);
          $('#header-icons .cart-quantity').html(res.cartQuantity);
        }
      },
      error: function(xhr, textStatus, error) {
        console.log(xhr.statusText);
        console.log(textStatus);
        console.log(error);
      },
    });
  });

  $('.member-tabs .tabs-title').on('click', function() {
    if ($(this).is(':first-child')) {
      $('.member-tabs-content .tabs-hero').slideUp(300);
      $('.member__hero').slideDown(300);
      $('.member-tabs').removeClass('tabsToPills');
    } else {
      $('.member__hero').slideUp(300);
      $('.member-tabs').addClass('tabsToPills');
      $('.member-tabs-content .tabs-hero__title').html(
        $(this)
          .find('> a')
          .text()
      );
      $('.member-tabs-content .tabs-hero').slideDown(300);
    }
  });

  // Member Tour

  $('#start-tour').on('click', function() {
    $(this)
      .closest('.member-welcome')
      .fadeOut();
    profileTour($(this).attr('data-action'));
  });

  $('.profile-tour').on('click', '.tour-action', function(e) {
    e.preventDefault();
    profileTour($(this).attr('data-action'));
  });

  $('#tour-end').on('click', function() {
    $(this)
      .closest('.tour-ended')
      .fadeOut();
    let postID = $(this).attr('data-post-id');
    $.ajax({
      url: myAjax.url,
      data: {
        action: 'profile_show_tour',
        postID: postID,
        value: '0',
      },
      type: 'POST',
      error: function(xhr, textStatus, error) {
        console.log(xhr.statusText);
        console.log(textStatus);
        console.log(error);
      },
    });
  });

  $('.profile-tour-skip').on('click', function() {
    $('.profile-tour').fadeOut();
    let postID = $(this).attr('data-post-id');
    $.ajax({
      url: myAjax.url,
      data: {
        action: 'profile_show_tour',
        postID: postID,
        value: '0',
      },
      type: 'POST',
      error: function(xhr, textStatus, error) {
        console.log(xhr.statusText);
        console.log(textStatus);
        console.log(error);
      },
    });
  });

  /**
   * Isotope Filters
   */

  // flatten object by concatting values
  function concatValues(obj) {
    let value = '';
    for (let prop in obj) {
      value += obj[prop];
    }
    return value;
  }

  // debounce so filtering doesn't happen every millisecond
  function debounce(fn, threshold) {
    let timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout(timeout);
      let args = arguments;
      let _this = this;

      function delayed() {
        fn.apply(_this, args);
      }

      timeout = setTimeout(delayed, threshold);
    };
  }

  // change is-checked class on buttons
  $('.button-group').each(function(i, buttonGroup) {
    let $buttonGroup = $(buttonGroup);
    $buttonGroup.on('click', 'li', function() {
      $buttonGroup.find('.is-checked').removeClass('is-checked');
      $(this).addClass('is-checked');
    });
  });

  /**
   * Portfolio Filter
   */
  //   if ($('#portfolio-items').length) {
  //     (function() {
  //       // store filter for each group
  //       let buttonFilters = {};
  //       let buttonFilter;
  //       // quick search regex
  //       let qsRegex;

  //       // init Isotope
  //       let $portfolio = new Isotope('#portfolio-items', {
  //         itemSelector: '.portfolio-item',
  //         percentPosition: true,
  //         masonry: {
  //           columnWidth: '.portfolio-item-sizer',
  //           gutter: 20,
  //           // horizontalOrder: true,
  //         },
  //         filter: function() {
  //           let $this = $(this);
  //           let searchResult = qsRegex ? $this.text().match(qsRegex) : true;
  //           let buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
  //           return searchResult && buttonResult;
  //         },
  //       });

  //       $('#portfolio-filters .button-group').on('click', 'li', function() {
  //         let $this = $(this);
  //         // get group key
  //         let $buttonGroup = $this.parents('.button-group');
  //         let filterGroup = $buttonGroup.attr('data-filter-group');
  //         // set filter for group
  //         buttonFilters[filterGroup] = $this.attr('data-filter');
  //         // combine filters
  //         buttonFilter = concatValues(buttonFilters);
  //         // Isotope arrange
  //         $portfolio.arrange();
  //       });

  //       // use value of search field to filter
  //       let $quicksearch = $('#portfolio-search').keyup(
  //         debounce(function() {
  //           qsRegex = new RegExp($quicksearch.val(), 'gi');
  //           $portfolio.arrange();
  //         })
  //       );

  //       $('#member-tabs').on('click', 'li', function() {
  //         $portfolio.layout();
  //       });
  //     })();
  //   }

  /**
   * Store Filter
   */
  if ($('#store-items').length) {
    (function() {
      // store filter for each group
      let buttonFilters = {};
      let buttonFilter;
      // quick search regex
      let qsRegex;

      // init Isotope
      const $store = new Isotope('#store-items', {
        itemSelector: '.store-item',
        filter: function() {
          let $this = $(this);
          let searchResult = qsRegex ? $this.text().match(qsRegex) : true;
          let buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
          return searchResult && buttonResult;
        },
      });

      $('#store-filters .button-group').on('click', 'li', function() {
        let $this = $(this);
        // get group key
        let $buttonGroup = $this.parents('.button-group');
        let filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        buttonFilters[filterGroup] = $this.attr('data-filter');
        // combine filters
        buttonFilter = concatValues(buttonFilters);
        // Isotope arrange
        $store.arrange();
      });

      // use value of search field to filter
      let $quicksearch = $('#store-search').keyup(
        debounce(function() {
          qsRegex = new RegExp($quicksearch.val(), 'gi');
          $store.arrange();
        })
      );

      $('#member-tabs').on('click', 'li', function() {
        $store.layout();
      });
    })();
  }

  /**
   * Content Filter
   */
  if ($('#content-items').length) {
    (function() {
      // store filter for each group
      let buttonFilters = {};
      let buttonFilter;
      // store date filter for each group
      let dateFilters = {};
      let dateFilter;
      // quick search regex
      let qsRegex;

      // init Isotope
      const $content = new Isotope('#content-items', {
        itemSelector: '.content-item',
        layoutMode: 'packery',
        percentPosition: true,
        filter: function() {
          let $this = $(this);
          let searchResult = qsRegex ? $this.text().match(qsRegex) : true;
          let buttonResult = buttonFilter ? $this.is('.' + buttonFilter) : true;
          let dateResult = dateFilter ? $this.data('date') == dateFilter : true;
          return searchResult && buttonResult && dateResult;
        },
      });

      $('#content-filters .button-group').on('click', 'li', function() {
        let $this = $(this);
        // get group key
        let $buttonGroup = $this.parents('.button-group');
        let filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        buttonFilters[filterGroup] = $this.attr('data-filter');
        // combine filters
        buttonFilter = concatValues(buttonFilters);
        // Isotope arrange
        $content.arrange();
      });

      $('#content-date-filter .button-group').on('click', 'li', function() {
        let $this = $(this);

        let $buttonGroup = $this.parents('.button-group');
        let filterGroup = $buttonGroup.attr('data-filter-group');

        dateFilters[filterGroup] = $this.attr('data-filter');
        dateFilter = concatValues(dateFilters);

        $content.arrange();
      });

      // use value of search field to filter
      let $quicksearch = $('#content-search').keyup(
        debounce(function() {
          qsRegex = new RegExp($quicksearch.val(), 'gi');
          $content.arrange();
        })
      );

      $('#member-tabs').on('click', 'li', function() {
        $content.layout();
      });
    })();
  }

  /**
   * Network Filter
   */
  if ($('#network-items').length) {
    (function() {
      // store filter for each group
      let buttonFilters = {};
      let buttonFilter;
      // quick search regex
      let qsRegex;

      // init Isotope
      const $network = new Isotope('#network-items', {
        itemSelector: '.network-item',
        filter: function() {
          let $this = $(this);
          let searchResult = qsRegex ? $this.text().match(qsRegex) : true;
          let buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
          return searchResult && buttonResult;
        },
      });

      $('#network-filters .button-group').on('click', 'li', function() {
        let $this = $(this);
        // get group key
        let $buttonGroup = $this.parents('.button-group');
        let filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        buttonFilters[filterGroup] = $this.attr('data-filter');
        // combine filters
        buttonFilter = concatValues(buttonFilters);
        // Isotope arrange
        $network.arrange();
      });

      // use value of search field to filter
      let $quicksearch = $('#network-search').keyup(
        debounce(function() {
          qsRegex = new RegExp($quicksearch.val(), 'gi');
          $network.arrange();
        })
      );

      $('#member-tabs').on('click', 'li', function() {
        $network.layout();
      });
    })();
  }

  /**
   * Inspiration Filter
   */
  if ($('#inspiration-items').length) {
    (function() {
      // store filter for each group
      let buttonFilters = {};
      let buttonFilter;
      // quick search regex
      let qsRegex;

      // init Isotope
      const $content = new Isotope('#inspiration-items', {
        itemSelector: '.inspiration-item',
        layoutMode: 'packery',
        filter: function() {
          let $this = $(this);
          let searchResult = qsRegex ? $this.text().match(qsRegex) : true;
          let buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
          return searchResult && buttonResult;
        },
      });

      $('#inspiration-filters .button-group').on('click', 'li', function() {
        let $this = $(this);
        // get group key
        let $buttonGroup = $this.parents('.button-group');
        let filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        buttonFilters[filterGroup] = $this.attr('data-filter');
        // combine filters
        buttonFilter = concatValues(buttonFilters);
        // Isotope arrange
        $content.arrange();
      });

      // use value of search field to filter
      let $quicksearch = $('#inspiration-search').keyup(
        debounce(function() {
          qsRegex = new RegExp($quicksearch.val(), 'gi');
          $content.arrange();
        })
      );

      $('#member-tabs').on('click', 'li', function() {
        $content.layout();
      });
    })();
  }

  if ($('#dashboard-boxes').length) {
    let key = $('#dashboard-boxes').data('key');

    let $dashboardBoxes = $('#dashboard-boxes').packery({
      itemSelector: '.dashboard-box',
    });

    let $orderCards = [];

    $dashboardBoxes.find('.dashboard-box').each(function(i, gridItem) {
      if (!$(gridItem).hasClass('draggable')) {
        let draggie = new Draggabilly(gridItem);
        $(gridItem)
          .css({ cursor: 'move' })
          .addClass('draggable');
        // bind drag events to Packery
        $dashboardBoxes.packery('bindDraggabillyEvents', draggie);
      }
    });

    $dashboardBoxes.on('dragEnd', function() {
      $dashboardBoxes.packery('layout');

      $orderCards.length = 0;

      let itemElems = $dashboardBoxes.packery('getItemElements');
      $(itemElems).each(function(i, itemElem) {
        $(itemElem).attr('data-order', i);

        if (itemElem.dataset.id) {
          $orderCards.push(itemElem.dataset.id);
        }
      });
      //console.log($orderCards);

      $.ajax({
        url: myAjax.url,
        data: {
          action: 'dashboard_cards',
          cards_id: $orderCards,
          key: key,
        },
        type: 'POST',
        error: function(xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          console.log(error);
        },
      });
    });

    $('#dashboard-boxes .dashboard-boxes__menu').on('click', 'li', function() {
      let itemElems;
      switch ($(this).attr('data-action')) {
        case 'add':
          $('#dscards-add').fadeIn();
          itemElems = $dashboardBoxes.packery('getItemElements');
          $orderCards.length = 0;
          $(itemElems).each(function(i, itemElem) {
            if (itemElem.dataset.id) {
              $orderCards.push(itemElem.dataset.id);
            }
          });
          $('#dscards-add input[type="checkbox"]').on('change', function() {
            if (this.checked) {
              if (this.dataset.id) {
                $orderCards.push(this.dataset.id);
              }
            } else {
              if (this.dataset.id) {
                $orderCards = $orderCards.filter(e => e !== this.dataset.id);
              }
            }
            //console.log($orderCards);
          });
          $('#dscards-save').on('click', function() {
            $.ajax({
              url: myAjax.url,
              data: {
                action: 'dashboard_cards',
                cards_id: $orderCards,
                key: key,
              },
              type: 'POST',
              success: function() {
                location.reload();
              },
              error: function(xhr, textStatus, error) {
                console.log(xhr.statusText);
                console.log(textStatus);
                console.log(error);
              },
            });
          });
          break;
        case 'hide':
          var $currBox = $(this).closest('.dashboard-box');
          $dashboardBoxes.packery('remove', $currBox).packery('layout');
          itemElems = $dashboardBoxes.packery('getItemElements');
          $orderCards.length = 0;
          $(itemElems).each(function(i, itemElem) {
            if (itemElem.dataset.id) {
              $orderCards.push(itemElem.dataset.id);
            }
          });
          //console.log($orderCards);
          $.ajax({
            url: myAjax.url,
            data: {
              action: 'dashboard_cards',
              cards_id: $orderCards,
              key: key,
            },
            type: 'POST',
            success: function() {
              $('#dscards-add')
                .find(`input[data-id="${$currBox.attr('data-id')}"]`)
                .prop('checked', false);
            },
            error: function(xhr, textStatus, error) {
              console.log(xhr.statusText);
              console.log(textStatus);
              console.log(error);
            },
          });
          break;
      }
    });
  }

  $('#dashboard-connect').on('click', '.connect-accept', function() {
    $('#connect-accept').fadeIn();
    let connectItem = this.closest('.connect__item');
    if (connectItem.dataset.member_id) {
      $.ajax({
        url: myAjax.url,
        data: {
          action: 'accept_connect',
          memberID: connectItem.dataset.member_id,
        },
        type: 'POST',
        success: function() {
          connectItem.remove();
        },
        error: function(xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          console.log(error);
        },
      });
    }
  });

  $('#dashboard-connect').on('click', '.connect-ignore', function() {
    $('#connect-ignore').fadeIn();
    let connectItem = this.closest('.connect__item');
    if (connectItem.dataset.member_id) {
      $.ajax({
        url: myAjax.url,
        data: {
          action: 'ignore_connect',
          memberID: connectItem.dataset.member_id,
        },
        type: 'POST',
        success: function() {
          connectItem.remove();
        },
        error: function(xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          console.log(error);
        },
      });
    }
  });

  $('#banner-slider').on('click', '.remove-banner-slide', function(e) {
    e.preventDefault();
    if (confirm('Are you sure you want to remove this slide?')) {
      let key = this.closest('#banner-slider').dataset.key;
      console.log(key);
      let slide = this.closest('.dashboard-banner');
      if (slide.dataset.id) {
        $.ajax({
          url: myAjax.url,
          data: {
            action: 'remove_banner_slide',
            slideID: slide.dataset.id,
            key: key,
          },
          type: 'POST',
          success: function() {
            slide.remove();
            $('#banner-slider').slick('reinit');
          },
          error: function(xhr, textStatus, error) {
            console.log(xhr.statusText);
            console.log(textStatus);
            console.log(error);
          },
        });
      }
    }
  });

  $('#primaryData').on('change', '#avatar', function(input) {
    if (input.target.files && input.target.files[0]) {
      var reader = new FileReader();

      reader.onload = function(e) {
        $('#preview-avatar').css('background-image', `url(${e.target.result})`);
      };

      reader.readAsDataURL(input.target.files[0]);
    }
  });

  $('.account-accordion').on('click', '.card-remove', function(e) {
    e.preventDefault();
    $(this)
      .closest('.accordion-item')
      .fadeOut(400, function() {
        $(this).remove();
      });
  });

  $('.card-form').on('click', '.js-card-close', function(e) {
    e.preventDefault();
    $(this)
      .closest('.card-form__wrapp')
      .fadeOut();
  });

  $('#accountCard-add').on('click', function(e) {
    e.preventDefault();
    $('#card-form')
      .closest('.card-form__wrapp')
      .fadeIn();
  });

  $('#bankAccount-add').on('click', function(e) {
    e.preventDefault();
    $('#bank-form')
      .closest('.card-form__wrapp')
      .fadeIn();
  });

  /**
   * INITIALIZE AOS
   */
  AOS.init();

  resizeVideo();
  menuNavigation();
  stikyPricingHeader();

  if ($('.portfolio__ajax').length) {
    var $grid = document.querySelector('.portfolio__ajax');
    var iso = new Isotope($grid, {
      itemSelector: '.portfolio__item',

      //layoutMode: 'fitRows',
      layoutMode: 'packery',
    });
  }

  //var iso = $grid.data('isotope');

  var single_slider = $('.portfolio-single__slider');
  single_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.portfolio-single__nav',
    prevArrow: single_slider.next('.custom-arrows').find('.slick-prev'),
    nextArrow: single_slider.next('.custom-arrows').find('.slick-next'),
  });
  $('.portfolio-single__nav').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.portfolio-single__slider',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    infinite: false,
  });

  var modal_slider = $('.modal-portfolio__slider-items');
  modal_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.modal-portfolio__nav-items',
    arrows: false,
  });
  $('.modal-portfolio__nav-items').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.modal-portfolio__slider-items',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    infinite: false,
  });

  $('.expand').on('click', function(e) {
    e.preventDefault();

    $('body, html').css('overflow', 'hidden');
    $('.modal-portfolio').addClass('show');
  });

  $('.close-attachments a').on('click', function(e) {
    e.preventDefault();

    $('.modal-portfolio').removeClass('show');
    $('body, html').css('overflow', 'auto');
  });

  $('#filter-portfolio').slick({
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 7,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    prevArrow: $('.filter-portfolio__prev'),
    nextArrow: $('.filter-portfolio__next'),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#filter-portfolio').on('click', '.slick-slide', function(e) {
    e.stopPropagation();
    let index = $(this).data('slick-index');
    if ($('#filter-portfolio').slick('slickCurrentSlide') !== index) {
      $('#filter-portfolio').slick('slickGoTo', index);
    }
  });

  $('#filter-portfolio').on('beforeChange', function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $('.portfolio-search').val('');
    $(document)
      .find('.portfolio__load')
      .fadeOut();
    $('.sub-filter').fadeOut();

    let term_id = $('#filter-portfolio')
      .find(`[data-slick-index=${nextSlide}]`)
      .data('term_id');

    // $('#filter-portfolio__title').html(
    //   `<b>${$('#filter-portfolio')
    //     .find(`[data-slick-index=${nextSlide}]`)
    //     .text()}</b>`
    // );

    let data = {
      action: 'filter_portfolio',
      term_id: term_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.portfolio__ajax').empty();
      // $('.portfolio__ajax').append(response);
      // $grid.isotope('layout');
      $(document)
        .find('.load__wrap')
        .remove();
      let items = $(response);
      // $grid.append(items);
      iso.insert(items);
      iso.layout();
      // $grid.isotope('reloadItems');
      // iso.appended(items);
      // iso.layout();
      setTimeout(function() {
        // $grid.isotope();
        iso.layout();
      }, 100);
      $('.portfolio__ajax').attr('data-per-page', iso.items.length);
    });
  });

  $('.portfolio-search').on('keyup', function() {
    var search = $(this).val();
    $(this).addClass('changing');
    if (search.length !== 0) {
      $('.sub-filter').fadeIn();
      $(document)
        .find('.portfolio__load')
        .fadeOut();
    } else {
      $('.sub-filter').fadeOut();
      $(document)
        .find('.portfolio__load')
        .fadeIn();
    }

    var term_id = $('#filter-portfolio')
      .find('.slick-current')
      .data('term_id');

    var data = {
      action: 'search_portfolio',
      search: search,
      term_id: term_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.portfolio__ajax').empty();
      // $('.portfolio__ajax').append(response);
      // $grid.isotope('layout');
      var items = $(response);
      iso.insert(items);
      iso.layout();
      // $grid.isotope('reloadItems');
      // iso.appended(items);
      // iso.layout();
      setTimeout(function() {
        // $grid.isotope();
        iso.layout();
      }, 500);
      // $grid.append(items);
      // iso.insert(items);
      // $grid.isotope('reloadItems');
      // setTimeout(function() {
      //   $grid.isotope();
      // }, 500);
      // $('.portfolio__ajax').attr('data-per-page', iso.items.length);
    });
  });

  $('.portfolio-search').on('keyup', function() {
    var search = $(this).val();
    var ppp = $('.portfolio__ajax').attr('data-per-page');
    var data = {
      action: 'search_live_filter',
      search: search,
      ppp: ppp,
    };

    jQuery.post(myAjax.url, data, function(response) {
      var wrap = $('.sub-filter');
      wrap.find('.sub-filter__categories').remove();
      wrap.prepend(response);
    });
  });

  $(document).on('click', '.portfolio__load', function(e) {
    e.preventDefault();

    var search = null;
    var term_id = $('#filter-portfolio')
      .find('.slick-current')
      .data('term_id');

    if ($('.portfolio-search').hasClass('changing')) {
      search = $('.portfolio-search').val();
    }

    var offset = $('.portfolio__ajax').attr('data-per-page');
    var posts_count = $(this).attr('data-count');

    var data = {
      action: 'portfolio_load',
      search: search,
      term_id: term_id,
      offset: offset,
    };

    jQuery.post(myAjax.url, data, function(response) {
      if (parseInt(posts_count) > parseInt(offset)) {
        $(document)
          .find('.portfolio__load')
          .fadeIn();
      } else {
        $(document)
          .find('.portfolio__load')
          .fadeOut();
      }
      var items = $(response);
      // $grid.append(items);
      // iso.insert(items);
      iso.insert(items);
      iso.layout();
      $('.portfolio__ajax').attr('data-per-page', iso.items.length);
    });
  });

  $(document).on('click', '.sub-filter__categories li a', function(e) {
    e.preventDefault();
    $('.sub-filter').fadeOut();

    $('.portfolio-search').val('');

    var term_id = $(this).attr('data-id');

    let slideIndex = $('#filter-portfolio')
      .find(`[data-term_id=${term_id}]`)
      .data('slick-index');
    if ($('#filter-portfolio').slick('slickCurrentSlide') !== slideIndex) {
      $('#filter-portfolio').slick('slickGoTo', slideIndex);
    }

    var data = {
      action: 'filter_portfolio',
      term_id: term_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.portfolio__ajax').empty();
      // $('.portfolio__ajax').append(response);
      // $grid.isotope('layout');
      var items = $(response);
      // $grid.append(items);
      // iso.insert(items);
      // $grid.isotope('reloadItems');
      // setTimeout(function() {
      //   $grid.isotope();
      // }, 100);
      iso.insert(items);
      iso.layout();
      setTimeout(function() {
        iso.layout();
      }, 100);
      $('.portfolio__ajax').attr('data-per-page', iso.items.length);
    });
  });

  /* Knowledgebase Start */
  var slickIndex = $('#center-slide').data('index');

  $('#filter-kbcategory').slick({
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: slickIndex,
    rows: 0, // Prevent generating extra markup
    prevArrow: $('.filter-kbcategory__prev'),
    nextArrow: $('.filter-kbcategory__next'),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#filter-kbcategory').on('click', '.slick-slide', function(e) {
    e.stopPropagation();
    let index = $(this).data('slick-index');
    if ($('#filter-kbcategory').slick('slickCurrentSlide') !== index) {
      $('#filter-kbcategory').slick('slickGoTo', index);
    }
  });

  $('#filter-kbcategory').on('beforeChange', function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $('.knowledgebase-search').val('');
    $(document)
      .find('.knowledgebase__load')
      .fadeOut();
    //$('.sub-filter').fadeOut();

    let term_id = $('#filter-kbcategory')
      .find(`[data-slick-index=${nextSlide}]`)
      .data('term_id');
    if (term_id == 'all') {
      term_id = null;
    }
    kb_load(term_id, 0);
  });

  var is_loading_more_knowledgebase = false;

  $(document).scroll(function() {
    if (!$('#knowledgebase_page_scroll_indicator').length) return;
    var top = $(
      '#knowledgebase_page_scroll_indicator'
    )[0].getBoundingClientRect().top;
    var screenHeight = $(window).height();
    if (top - screenHeight < 200 && !is_loading_more_knowledgebase) {
      is_loading_more_knowledgebase = true;
      kb_load();
    }
  });

  $('.kb__load').click(function(event, slick, currentSlide, nextSlide) {
    is_loading_more_knowledgebase = true;
    kb_load();
  });

  function kb_load(
    term_id = $('.kb__ajax').data('category'),
    offset = $('.kb__ajax').attr('data-per-page')
  ) {
    $('.kb__load').fadeOut();
    var data = {
      action: 'filter_kb',
      offset: offset,
      term_id: term_id,
      search: $('input[name=q]').val(),
    };
    jQuery.post(myAjax.url, data, function(response) {
      $('.kb__ajax').html(response);
      $('.kb__ajax').attr('data-per-page', offset + 1);
      is_loading_more_knowledgebase = false;
    });
  }

  $(document).on('submit', '#kb-search', function(e) {
    e.preventDefault();
    kb_load();
  });

  $('#kb-search input[name=q]').change(function() {
    if (!$('#kb-search input[name=q]').val()) {
      kb_load();
    }
  });


  $('.filter-glossarycategory__item').on('click', function(e) {
    $('.filter-glossarycategory__item').removeClass("slick-current");
    $(this).addClass("slick-current");
    e.stopPropagation();
    let index = $(this).data('term_id');
    if(index == 'all'){
      $('.acronym').show();
      $('.term').show();
    } else if(index == 'term'){
      $('.acronym').hide();
      $('.term').show();
    } else if(index == 'acronym'){
      $('.acronym').show();
      $('.term').hide();
    }

  });

  // Old Filtration - WLA
  // $(document).on('click', '.kb-category', function(e) {
  //   e.preventDefault();
  //   console.log($(this).data('id'));
  //   kb_filtration($(this).data('id'));
  // });
  // $(document).on('click', '#kb-pagination a', function(e) {
  //   e.preventDefault();
  //   var thisHref = $(this).attr('href'),
  //     paged = thisHref.split('paged=')[1];
  //   kb_filtration('', paged);
  // });
  // function kb_filtration(kb_cat, paged) {
  //   if (!paged) {
  //     paged = $('#kb-search').data('paged');
  //   }
  //   if (!kb_cat) {
  //     kb_cat = $('#kb-search').data('category');
  //   }
  //   $.ajax({
  //     url: myAjax.url,
  //     data: {
  //       action: 'kb_search',
  //       kb_s: $('#kb-search input').val(),
  //       term_id: kb_cat,
  //       paged: paged,
  //     },
  //     type: 'POST',
  //     success: function(res) {
  //       if (res) {
  //         $('#kb-wrap').html(res);
  //         console.log(res);
  //       }
  //     },
  //     error: function(xhr, textStatus, error) {
  //       console.log(xhr.statusText);
  //       console.log(textStatus);
  //       console.log(error);
  //     },
  //   });
  // }
  /* Knowledgebase End */

  $(document).on('click', '.sub-filter__reset', function(e) {
    e.preventDefault();

    $(document)
      .find('.sub-filter')
      .fadeOut();
  });
  $(document).on('click', '.connect-btn', function(e) {
    e.preventDefault();
    var member_id = $(this).attr('data-member-id');
    var user_id = $(this).attr('data-user-id');
    var data = {
      action: 'connect_users',
      member_id: member_id,
      user_id: user_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      window.location.reload();
    });    
  });

  $(document).on('click', '.unconnect-btn', function(e) {
    e.preventDefault();
    var member_id = $(this).attr('data-member-id');
    var user_id = $(this).attr('data-user-id');
    var data = {
    action: 'unconnect_users',
    member_id: member_id,
    user_id: user_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
    window.location.reload();
    });    
  });


  $(document).on('click', '.btn-share', function(e) {
    e.preventDefault();
    $('.share-section').fadeIn();
  });

  $(document).on('click', '.share-section__close', function(e) {
    e.preventDefault();
    $('.share-section').fadeOut();
  });

  $(document).on('click', '.bookmark', function(e) {
    e.preventDefault();

    var post_id = $(this).attr('data-id');

    var data = {
      action: 'bookmark_post',
      post_id: post_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
    });
  });

  $('.share__link').click(function(e) {
    e.preventDefault();
    var wpWidth = $(window).width(),
      wpHeight = $(window).height();
    window.open(
      $(this).attr('href'),
      'Share',
      'top=' +
        (wpHeight - 400) / 2 +
        ',left=' +
        (wpWidth - 600) / 2 +
        ',width=600,height=400'
    );
  });

  var el = document.getElementById('overlayBtn');
  if (el) {
    el.addEventListener('click', function() {
      copyToClipboard(document.getElementById('copyLink'));
    });
  }

  function copyToClipboard(elem) {
    // create hidden text element, if it doesn't already exist
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement('textarea');
        target.style.position = 'absolute';
        target.style.left = '-9999px';
        target.style.top = '0';
        target.id = targetId;
        document.body.appendChild(target);
      }
      target.textContent = elem.textContent;
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = '';
    }
    return succeed;
  }

  // $('.portfolio__ajax').imagesLoaded(function() {
  //   $grid.isotope({
  //   });
  // });

  $('.select2').select2({
    minimumResultsForSearch: -1,
  });

  //   $('#filter-profession, #filter-location').select2({
  //     customClass: 'filter-select',
  //   });

  $('#graphicDesign, #hours, #styleColor, #audienceType').select2({
    minimumResultsForSearch: -1,
  });

  $('.hero-categories').select2({
    minimumResultsForSearch: -1,
    customClass: 'hero-select',
  });

  $('#currency').select2({
    minimumResultsForSearch: -1,
    customClass: 'currency-select',
  });

  $('#delivery').select2({
    minimumResultsForSearch: -1,
    customClass: 'delivery-select',
  });

  $(
    '#employment, #qualification, #edit-employment, #employment, .qualification'
  ).select2({
    minimumResultsForSearch: -1,
    customClass: 'employment-select',
  });

  $('#cart-refer').select2({
    placeholder: 'Start Typing the First Name',
    allowClear: true,
    // matcher: true,
  });

  $('.cart-refer').on('click', 'h5', function() {
    $('.cart-refer .sliding-form ').toggle();
  });

  $('#show_sh').on('change', function() {
    $('#shipping').toggle();
  });

  $('.statistic-table').on('change', 'th input[type="checkbox"]', function() {
    let thisVal = $(this).prop('checked');
    $(this)
      .closest('.statistic-table')
      .find('input[type="checkbox"]')
      .prop('checked', thisVal);
  });

  // function iformat(icon) {
  //   if (!icon.id) {
  //     return icon.text;
  //   }
  //   var originalOption = icon.element;
  //   return $(
  //     '<span><i class="fa fa-fw ' +
  //       $(originalOption).data('icon') +
  //       '"></i> ' +
  //       icon.text +
  //       '</span>'
  //   );
  // }

  function selectRefresh() {
    $(document)
      .find('.ajax-social .social-row__item')
      .each(function() {
        $(this)
          .find('.social-list-select')
          .select2({
            minimumResultsForSearch: -1,
            customClass: 'currency-select',
          });
      });
  }

  $(document)
    .find('#productsPerPage')
    .select2({
      minimumResultsForSearch: -1,
    });

  $('#nwk-advanced').on('click', function(e) {
    e.preventDefault();
    let text = $(this).text();
    $('.nwk-filter__wrap').toggleClass('nwk-advanced');
    $(this).text(
      text == 'Advanced Search' ? 'Back to Basic Search' : 'Advanced Search'
    );
  });

  function nwkFilter() {
    var profession = $(document)
      .find('#filter-profession')
      .val();
    var location = $(document)
      .find('#filter-location')
      .val();
    var search = $('.network-search').val();
    var offset = $('.nwk__load').attr('data-click');
    var wrap = $('.nwk__ajax');

    // console.log(profession);
    // console.log(location);
    // console.log(search);
    // console.log(offset);

    var data = {
      action: 'filter_network',
      profession: profession,
      location: location,
      search: search,
      offset: offset,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
      wrap.find('.nwk__item').each(function() {
        var width = $(this).width();
        $(this).height(width);
      });
      var count = $('.nwk__item').length;

      console.log('a: ' + count);

      if (count) {
        $(document)
          .find('.nwk__count span')
          .text('1 - ' + count);

        $(document)
          .find('.nwk__count')
          .show();
        $(document)
          .find('.nwk__count_none')
          .hide();
      } else {
        $(document)
          .find('.nwk__count')
          .hide();
        $(document)
          .find('.nwk__count_none')
          .show();
      }
    });
  }

  $(document).on('change keyup', '.network-search', nwkFilter);

  $('#nwk-submit').on('click', nwkFilter);

  var is_loading_more_network_profiles = false;
  $(document).ready(function() {
    $(document).scroll(function() {
      if (!$('#network_page_scroll_indicator').length) return;
      var top = $('#network_page_scroll_indicator')[0].getBoundingClientRect()
        .top;
      var screenHeight = $(window).height();
      if (top - screenHeight < 200 && !is_loading_more_network_profiles) {
        is_loading_more_network_profiles = true;
        $('.nwk__load').click();
      }
    });
  });

  $(document).on('click', '.nwk__load', function(e) {
    e.preventDefault();

    var profession = $(document)
      .find('#filter-profession')
      .val();
    var location = $(document)
      .find('#filter-location')
      .val();
    var search = $('.network-search').val();
    var offset = $(document)
      .find('.nwk__load')
      .attr('data-click');
    var wrap = $('.nwk__ajax');

    var data = {
      action: 'load_network',
      profession: profession,
      location: location,
      search: search,
      offset: offset,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $(document)
        .find('.nwk__load')
        .remove();
      wrap.append(response);
      wrap.find('.nwk__item').each(function() {
        var width = $(this).width();
        $(this).height(width);
      });
      var count = $('.nwk__item').length;

      if (count) {
        $(document)
          .find('.nwk__count span')
          .text('1 - ' + count);

        $(document)
          .find('.nwk__count')
          .show();
        $(document)
          .find('.nwk__count_none')
          .hide();
      } else {
        $(document)
          .find('.nwk__count')
          .hide();
        $(document)
          .find('.nwk__count_none')
          .show();
      }

      if (count < 1000) {
        is_loading_more_network_profiles = false;
      }
    });
  });

  $('#filter-professions').slick({
    initialSlide: 0,
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 7,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    prevArrow: $('.filter-professions__prev'),
    nextArrow: $('.filter-professions__next'),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  var slickClickingSameProfessionalGategorySlide = false;
  $('#filter-professions').on('click', '.slick-slide', function(e) {
    e.stopPropagation();
    let index = $(this).data('slick-index');
    if ($('#filter-professions').slick('slickCurrentSlide') == index) {
      slickClickingSameProfessionalGategorySlide = true;
    } else {
      slickClickingSameProfessionalGategorySlide = false;
    }

    $('#filter-professions').slick('slickGoTo', index);
  });

  $('#filter-professions').on('afterChange', function(
    event,
    slick,
    currentSlide
  ) {
    if (slickClickingSameProfessionalGategorySlide) {
      $('#filter-profession').val('');
      $('.slick-slide').removeClass('slick-current');
      console.log('a');
    } else {
      $('#filter-profession').val(
        $('#filter-professions')
          .find(`[data-slick-index=${currentSlide}]`)
          .data('term_id')
      );
      console.log('b');
    }
    $('.network-search').keyup();
  });

  $(document).on('change keyup', '#member_search', function(e) {
    e.preventDefault();
    var member_status = $('#member-curation-tabs .is-active a').data('tab');
    var paged = 1;
    var search = $('#member_search').val();
    var old_new = $('#old-new').val() == 2 ? 'DESC' : 'ASC';
    var posts_per_page = $('#per-page').val() > 1 ? $('#per-page').val() : 9;
    var profession = $('#content-type').val();

    var data = {
      action: 'members_pending',
      paged: paged,
      member_status: member_status,
      old_new: old_new,
      posts_per_page: posts_per_page,
      search: search,
      profession: profession,
    };

    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: myAjax.url,
      data: data,
      success: function(data) {
        $('#' + member_status + ' .store-items').empty();
        $('#' + member_status + ' .store-items').append(data);
        $('#' + member_status + ' .paged').val(paged);
        $('#' + member_status + ' .store-items .time').each(function() {
          var utcTime = new Date(Date.parse($(this).text() + ' UTC'));
          var options = { month: '2-digit', day: '2-digit', year: '2-digit' };
          var localTimeString = utcTime.toLocaleString('en-US', options);
          var timeArray = localTimeString.split(',');
          $(this).text(timeArray[0]);
        });
      },
    });
  });

  $(document).on('click', '.ajax-data', function(e) {
    e.preventDefault();
    var $this = $(this);
    var member_status = $('#member-curation-tabs .is-active a').data('tab');
    var paged = parseInt($('#' + member_status + ' .paged').val());
    var load_more = $(this).data('status');
    if (load_more) {
      paged = paged + 1;
    } else {
      paged = 1;
    }
    var old_new = $('#old-new').val() == 2 ? 'DESC' : 'ASC';
    var posts_per_page = $('#per-page').val() > 1 ? $('#per-page').val() : 9;
    var profession = $('#content-type').val();
    var search = $('#member_search').val();
    var data = {
      action: 'members_pending',
      paged: paged,
      member_status: member_status,
      old_new: old_new,
      posts_per_page: posts_per_page,
      search: search,
      profession: profession,
    };

    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: myAjax.url,
      data: data,
      success: function(data) {
        //check if data is empty
        if (data == '') {
          //hide this button
          $this.hide();

        } else {
        if (load_more) {
          $('#' + member_status + ' .store-items').append(data);
        } else {
          $('#' + member_status + ' .store-items').empty();
          $('#' + member_status + ' .store-items').append(data);
        }
        $('#' + member_status + ' .paged').val(paged);
        $('#' + member_status + ' .store-items .time').each(function() {
          var utcTime = new Date(Date.parse($(this).text() + ' UTC'));
          var options = { month: '2-digit', day: '2-digit', year: '2-digit' };
          var localTimeString = utcTime.toLocaleString('en-US', options);
          var timeArray = localTimeString.split(',');
          $(this).text(timeArray[0]);
        });
       }
      },
    });
  });

  $(document).on('select2:select', '.select2.ajax-data', function() {
    var member_status = $('#member-curation-tabs .is-active a').data('tab');
    var paged = 1;
    var old_new = $('#old-new').val() == 2 ? 'DESC' : 'ASC';
    var posts_per_page = $('#per-page').val() > 1 ? $('#per-page').val() : 9;
    var profession = $('#content-type').val();
    var search = $('#member_search').val();
    var data = {
      action: 'members_pending',
      paged: paged,
      member_status: member_status,
      old_new: old_new,
      posts_per_page: posts_per_page,
      search: search,
      profession: profession,
    };

    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: myAjax.url,
      data: data,
      success: function(data) {
        $('#' + member_status + ' .store-items').empty();
        $('#' + member_status + ' .store-items').append(data);
        $('#' + member_status + ' .paged').val(paged);
        $('#' + member_status + ' .store-items .time').each(function() {
          var utcTime = new Date(Date.parse($(this).text() + ' UTC'));
          var options = { month: '2-digit', day: '2-digit', year: '2-digit' };
          var localTimeString = utcTime.toLocaleString('en-US', options);
          var timeArray = localTimeString.split(',');
          $(this).text(timeArray[0]);
        });
      },
    });
  });

  $(document).on('change', '#billing_as_shipping', function() {
    if ($(this).is(':checked')) {
      $('#street-sh').val($('#street').val());
      $('#city-sh').val($('#city').val());
      $('#state-sh')
        .val($('#state').val())
        .trigger('change');
      $('#zip-sh').val($('#zip').val());
      $('#country-sh')
        .val($('#country').val())
        .trigger('change');
    }
  });

  $(document).on(
    'click change',
    '.ajax-filter input, #productsPerPage',
    function() {
      var categories = [];
      var tags = [];
      var ppp = $('#productsPerPage').val();
      var paged = $('#currentPage').val();
      $('.product__filter-categories input:checked').each(function() {
        categories.push($(this).val());
      });
      $('.product__filter-tags input:checked').each(function() {
        tags.push($(this).val());
      });
      var wrap = $('.store-items');

      var data = {
        action: 'products_filter',
        categories: categories,
        tags: tags,
        ppp: ppp,
        paged: paged,
      };

      var dsFiltersSearch = $('#ds-filters-search');

      if (dsFiltersSearch.val() !== '') {
        data.search = dsFiltersSearch.val();
      }

      jQuery.post(myAjax.url, data, function(response) {
        wrap.empty();
        wrap.append(response);
        $(document)
          .find('#productsPerPage')
          .select2({
            minimumResultsForSearch: -1,
          });
      });
    }
  );

  $(document).on('submit', '.js-filters-search-wrap', function() {
    event.preventDefault();
    var thisSearch = $(this)
      .find('.js-filters-search')
      .val();
    console.log(thisSearch);
    $('.js-filters-search').val('');

    $(this)
      .find('.js-filters-search')
      .val(thisSearch);
    var categories = [];
    var tags = [];
    var ppp = $('#productsPerPage').val();
    var paged = $('#currentPage').val();
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: paged,
      search: thisSearch,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
      $(document)
        .find('#productsPerPage')
        .select2({
          minimumResultsForSearch: -1,
        });
    });
  });

  $(document).on('keyup', '#currentPage', function() {
    var categories = [];
    var tags = [];
    var ppp = $(document)
      .find('#productsPerPage')
      .val();
    var paged = $(document)
      .find('#currentPage')
      .val();
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: paged,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
      $(document)
        .find('#productsPerPage')
        .select2({
          minimumResultsForSearch: -1,
        });
    });
  });

  $(document).on('click', '.allmax', function(e) {
    e.preventDefault();
    var categories = [];
    var tags = [];
    var ppp = $(document)
      .find('#productsPerPage')
      .val();
    var paged = $(document)
      .find('#maxPage')
      .val();
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: paged,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
      $(document)
        .find('#productsPerPage')
        .select2({
          minimumResultsForSearch: -1,
        });
    });
  });

  $(document).on('click', '.allmin', function(e) {
    e.preventDefault();
    var categories = [];
    var tags = [];
    var ppp = $(document)
      .find('#productsPerPage')
      .val();
    var paged = 1;
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: paged,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
      $(document)
        .find('#productsPerPage')
        .select2({
          minimumResultsForSearch: -1,
        });
    });
  });

  $(document).on('click', '.minus', function(e) {
    e.preventDefault();
    var categories = [];
    var tags = [];
    var ppp = $(document)
      .find('#productsPerPage')
      .val();
    var paged = $(document)
      .find('#currentPage')
      .val();
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: paged - 1,
    };
    if (parseInt(paged) - 1 != 0) {
      jQuery.post(myAjax.url, data, function(response) {
        wrap.empty();
        wrap.append(response);
        $(document)
          .find('#productsPerPage')
          .select2({
            minimumResultsForSearch: -1,
          });
      });
    }
  });

  $(document).on('click', '.plus', function(e) {
    e.preventDefault();
    var categories = [];
    var tags = [];
    var ppp = $(document)
      .find('#productsPerPage')
      .val();
    var paged = $(document)
      .find('#currentPage')
      .val();
    var max = $(document)
      .find('#maxPage')
      .val();
    $('.product__filter-categories input:checked').each(function() {
      categories.push($(this).val());
    });
    $('.product__filter-tags input:checked').each(function() {
      tags.push($(this).val());
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
      ppp: ppp,
      paged: parseInt(paged) + 1,
    };
    if (parseInt(paged) + 1 <= max) {
      jQuery.post(myAjax.url, data, function(response) {
        wrap.empty();
        wrap.append(response);
        $(document)
          .find('#productsPerPage')
          .select2({
            minimumResultsForSearch: -1,
          });
      });
    }
  });

  $('.clear-products').on('click', function(e) {
    e.preventDefault();

    var categories = [];
    var tags = [];

    $('.product__filter-categories input:checked').each(function() {
      $(this).prop('checked', false);
    });
    $('.product__filter-tags input:checked').each(function() {
      $(this).prop('checked', false);
    });
    var wrap = $('.store-items');

    var data = {
      action: 'products_filter',
      categories: categories,
      tags: tags,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      wrap.append(response);
    });
  });

  $('.flex-control-thumbs .slick-arrow').on('click', function() {
    $('.flex-control-thumbs .slick-slide').each(function() {
      if ($(this).hasClass('slick-current')) {
        $(this).trigger('click');
      }
    });
  });

  if ($('.taxonomy-mobile').length) {
    var load = true;
    $(window).scroll(function() {
      var wrap = $('.taxonomy-mobile .store-items');
      var scroll_data = $(document)
        .find('.taxonomy-mobile .scroll-data')
        .attr('data-scroll');
      var scroll_top = $(document)
        .find('.taxonomy-mobile .scroll-data')
        .offset().top;
      var taxonomy = $('.taxonomy-mobile .store-items').data('taxonomy');

      if ($(window).scrollTop() >= scroll_top - 400) {
        if (load) {
          var pages = $(document)
            .find('.taxonomy-mobile .store-items')
            .attr('data-count');
          if (scroll_data <= pages) {
            $('.loading-text').fadeIn();
          }
          load = false;
          $(document)
            .find('.taxonomy-mobile .scroll-data')
            .attr('data-scroll', parseInt(scroll_data) + 1);
          setTimeout(function() {
            var data = {
              action: 'taxonomy_ajax',
              scroll: parseInt(scroll_data),
              taxonomy: taxonomy,
            };

            jQuery.post(myAjax.url, data, function(response) {
              wrap.append(response);
              $('.loading-text').fadeOut();
            });
            return (load = true);
          }, 1000);
        }
      }
    });
  }

  if ($('.ajax-posts-list').length) {
    var $grid_blog = document.querySelector('.posts-list');
    var iso_blog = new Isotope($grid_blog, {
      itemSelector: '.posts-list__item',
      layoutMode: 'packery',
    });

    var load_posts = true;
    $(window).scroll(function() {
      let scroll_data = $(document)
        .find('.blog .scroll-data')
        .attr('data-scroll');
      let scroll_top = $(document)
        .find('.blog .scroll-data')
        .offset().top;

      if ($(window).scrollTop() >= scroll_top - 400) {
        if (load_posts) {
          var pages = $(document)
            .find('.posts-list')
            .attr('data-count');
          if (scroll_data < pages) {
            $('.loading-text').fadeIn();

            load = false;
            $(document)
              .find('.blog .scroll-data')
              .attr('data-scroll', parseInt(scroll_data) + 1);
            setTimeout(function() {
              var search = $('.search-blog').val();
              var catID = $('#filter-terms')
                .find('.slick-current')
                .data('term_id');

              var data = {
                action: 'posts_filter',
                cat_id: catID,
                search: search,
                offset: parseInt(scroll_data),
              };

              jQuery.post(myAjax.url, data, function(response) {
                // wrap.append(response);

                var items = $(response);
                iso_blog.insert(items);
                iso_blog.layout();
                setTimeout(function() {
                  iso_blog.layout();
                }, 100);
                $('.loading-text').fadeOut();
              });
              return (load_posts = true);
            }, 1000);
          }
        }
      }
    });
  }

  $('#filter-terms').slick({
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 7,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    prevArrow: $('.filter-terms__prev'),
    nextArrow: $('.filter-terms__next'),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('#filter-terms').on('click', '.slick-slide', function(e) {
    e.stopPropagation();
    let index = $(this).data('slick-index');
    if ($('#filter-terms').slick('slickCurrentSlide') !== index) {
      $('#filter-terms').slick('slickGoTo', index);
    }
  });

  $('#filter-terms').on('beforeChange', function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    let wrap = $('.posts-list');
    let search = $('.search-blog').val();
    let catID = $('#filter-terms')
      .find(`[data-slick-index=${nextSlide}]`)
      .data('term_id');

    let data = {
      action: 'posts_filter',
      cat_id: catID,
      search: search,
      offset: 0,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      let items = $(response);
      iso_blog.insert(items);
      iso_blog.layout();
      $(document)
        .find('.blog .scroll-data')
        .attr('data-scroll', 1);
      setTimeout(function() {
        iso_blog.layout();
      }, 100);
    });
  });

  $('.search-blog').on('keyup', function(e) {
    e.preventDefault();

    $(this).toggleClass('active');

    let wrap = $('.posts-list');
    let search = $('.search-blog').val();
    let catID = $('#filter-terms')
      .find('.slick-current')
      .data('term_id');

    let data = {
      action: 'posts_filter',
      cat_id: catID,
      search: search,
      offset: 0,
    };

    jQuery.post(myAjax.url, data, function(response) {
      wrap.empty();
      let items = $(response);
      iso_blog.insert(items);
      iso_blog.layout();
      $(document)
        .find('.blog .scroll-data')
        .attr('data-scroll', 1);
      setTimeout(function() {
        iso_blog.layout();
      }, 100);
    });
  });

  let left = 0;

  $('.scrollFilter').click(function(e) {
    e.preventDefault();
    if ($(':animated').length) {
      return false;
    }

    var right =
      parseInt($('.filter-terms').width()) - parseInt($(window).width());

    left -= 100;
    if ($('.filter-terms').width() - $(window).width() > left * -1) {
      $('html,body').animate(
        {
          scrollLeft: $('.filter-terms').css('left', left + 'px'),
        },
        800,
        function() {
          left += 10;
          $('html, body').animate(
            {
              scrollLeft: $('.filter-terms').css('left', left + 'px'),
            },
            500
          );
        }
      );
    } else {
      $('html,body').animate(
        {
          scrollLeft: $('.filter-terms').css('left', '-' + (right + 45) + 'px'),
        },
        800
      );
      setTimeout(function() {
        $('html, body').animate(
          {
            scrollLeft: $('.filter-terms').css('left', '0px'),
          },
          800
        );
        left = 0;
      }, 5000);
    }

    return left;
  });

  $('#anchor-list li a, .anchor-list li a').on('click', function(e) {
    var anchor = $(this).attr('href');
    e.preventDefault();

    $('#anchor-list li, .anchor-list li').each(function() {
      $(this).removeClass('active');
    });

    $(this)
      .closest('li')
      .addClass('active');

    $('html, body').animate(
      {
        scrollTop: $(anchor).offset().top - 50,
      },
      1000
    );
  });

  // $('.sidebar-edit').fancybox({
  //   minHeight: 0,
  //   smallBtn: false,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  //   afterShow: function() {
  //     wp.editor.initialize('dsavailability', {
  //       tinymce: {
  //         wpautop: true,
  //         plugins: 'lists',
  //         toolbar1: 'bold italic bullist',
  //         draggable_modal: true,
  //       },
  //       quicktags: true,
  //     });
  //   },
  // });

  $('.sidebar-edit, .js-popup-edit, .hero-tabs').on('click', function(e) {
    e.preventDefault();
    var modal_id = $(this).attr('href');

    $('body, html').css('overflow', 'hidden');
    $('.sidebar-popup').fadeOut();
    $(modal_id).fadeIn();
    var wrap_portfolio = $('#add_portfolio_type').find(
      '.sidebar-popup__wrapper'
    );

    var wrap_mm = $(modal_id).find('.sidebar-popup__wrapper');

    if (wrap_portfolio.length) {
      var offset = wrap_portfolio.offset();
      var top = offset.top;
      var p_left = offset.left;
      var width = wrap_portfolio.width();
      wrap_portfolio
        .prev('.sidebar-popup__close')
        .css('top', top + 'px')
        .css('left', p_left + width + 'px');
    }
    if (wrap_mm.length) {
        alignCloseBtn ();
        //setTimeout(alignCloseBtn, 500);
    }
  });

  $('.popup-tabs-switcher').on('click', function(e) {
    e.preventDefault();
    $('.popup-close').hide ();
    var modal_id = $(this).attr('href');
    $('.popup-tabs').fadeOut();
    $(modal_id).fadeIn(function () {
        alignCloseBtn ();
    });

    //alignCloseBtn ();
    //setTimeout(alignCloseBtn, 500);
  });

  $(document).on('click', '.js-billed-item-remove', function() {
    $(this)
      .closest('.billed-item')
      .remove();
  });

  $('#add_discount, #remove-discount').on('click', function() {
    $('#add_discount').toggle();
    $('#discount').slideToggle();
  });

  $('.notes a').on('click', function() {
    $(this)
      .hide()
      .parent()
      .find('textarea')
      .slideToggle()
      .parent()
      .find('label')
      .slideToggle();
  });

  function calculateBilled() {
    let subtotal = $('#grand-subtotal'),
      subtotalVal = 0,
      total = $('#grand-total'),
      totalVal = 0,
      useDiscount = $('#discount').is(':visible'),
      discountType = $('#discount-type').val(),
      discountVal = $('#discount-value').val();

    $('.billed-item').each(function() {
      let thisQuantity = $(this).find('[id*="quantity-"]'),
        thisCost = $(this).find('[id*="cost-"]'),
        // thisTax = $(this).find('[id*="tax-"]'),
        localTotal = $(this).find('[id*="total-"]'),
        localTotalVal = thisCost.val() * thisQuantity.val();
      localTotal.val(localTotalVal);
      subtotalVal += localTotalVal;
    });
    if (useDiscount) {
      if (discountType == '%') {
        totalVal = subtotalVal - (subtotalVal / 100) * discountVal;
      } else {
        totalVal = subtotalVal - discountVal;
      }
    } else {
      totalVal = subtotalVal;
    }

    subtotal.val(subtotalVal);
    total.val(totalVal);
  }

  $(document).on(
    'change',
    '.billed-item input, .billed-item select, #discount input, #discount select, #remove-discount',
    calculateBilled
  );

  $('.sidebar-popup__close, .js-popup-close, .draft_cancel').on(
    'click',
    function(e) {
      e.preventDefault();

      $('body, html').css('overflow-y', 'inherit');
      $('.sidebar-popup').fadeOut();
      $('.popup-close').hide ();
    }
  );

  $('.show__variations').on('click', function() {
    $(this)
      .closest('.sidebar-popup')
      .fadeOut();
  });

  $('.expand').on('click', function(e) {
    e.preventDefault();

    $('.acc-toggle').toggleClass('hide');
    // open all panels
    $(
      '.add__portfolio .accordion, .add__product .accordion, .add__service .accordion'
    ).foundation(
      'down',
      $(
        '.add__portfolio .accordion .accordion-content, .add__product .accordion .accordion-content, .add__service .accordion .accordion-content'
      )
    );
    $('body,html').css('overflow-y', 'auto');
  });

  $('.js-sliding__switcher').on('click', function() {
    event.preventDefault();
    var slidingForm = $(this).closest('.js-sliding');
    slidingForm.toggleClass('active');
    // if (slidingForm.hasClass('active')) {
    setTimeout(function() {
      slidingForm.find('input').focus();
    }, 700);
    // }
  });

  $('.close').on('click', function(e) {
    e.preventDefault();

    $('.acc-toggle').toggleClass('hide');
    // close all panels
    $(
      '.add__portfolio .accordion, .add__product .accordion, .add__service .accordion'
    ).foundation(
      'up',
      $(
        '.add__portfolio .accordion .accordion-content, .add__product .accordion .accordion-content, .add__service .accordion .accordion-content'
      )
    );
  });
  // $('.product-type-checker').on('click', function(e) {
  //   e.preventDefault();
  //   $('.sidebar-popup').fadeOut();
  //
  //   var modal_id = $(this).attr('href');
  //   $(modal_id).fadeIn();
  // });

  if ($('.publish-status').length) {
    setTimeout(function() {
      $('.publish-status').fadeOut();
    }, 10000);
  }

  $('.product-type-checker').on('mouseover', function() {
    var productType = $(this).data('product-type');
    $('.sidebar-popup__content > p')
      .hide()
      .removeClass('active');
    $('#' + productType).show();
  });

  // Upload images for the product gallery and create a previews
  /* eslint-disable */
  $(document).on('change', '#add-product-gallery__input', function() {
    var input = $(this);
    $('#image_update_add-product-gallery__input').val(1);
    try {
      var files = input[0].files;
      readmultifiles(files);
      $('#add-product-gallery__trigger').hide();
    } catch (err) {
      $(this)
        .parent()
        .find('.add-product-gallery__preview-empty--show')
        .attr(
          'src',
          "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%3E%3C/svg%3E"
        )
        .attr(
          'data-lazy-src',
          'http://mvp.designstudio.host/wp-content/themes/designstudio-mvp/assets/images/upload.svg'
        )
        .removeClass('lazyloaded')
        .removeClass('add-product-gallery__preview-empty--show');
      $(this)
        .prev()
        .show();
    }
  });

  $(document).on('change', '#add-portfolio-thumbnail__input', function() {
    var input = $(this);
    $('#image_update_add-portfolio-thumbnail__input').val(1);
    try {
      var files = input[0].files;
      readmultifiles2(files);
      $('#add-portfolio-thumbnail__trigger').hide();
    } catch (err) {
      $(this)
        .parent()
        .find('.add-portfolio-thumbnail__preview-empty--show')
        .attr(
          'src',
          "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%3E%3C/svg%3E"
        )
        .attr(
          'data-lazy-src',
          'http://mvp.designstudio.host/wp-content/themes/designstudio-mvp/assets/images/upload.svg'
        )
        .removeClass('lazyloaded')
        .removeClass('add-portfolio-thumbnail__preview-empty--show');
      $(this)
        .prev()
        .show();
    }
  });

  /* eslint-enable */
  function readmultifiles(files) {
    var reader = new FileReader();
    var file = files[0];
    reader.readAsDataURL(file);
    reader.onloadend = function(e) {
      var imageUrl = e.target.result;
      $('#preview_0')
        .find($('.add-product-gallery__preview-empty'))
        .addClass('add-product-gallery__preview-empty--show')
        .addClass('lazyloaded')
        .attr('src', imageUrl)
        .attr('data-lazy-src', imageUrl);
    };
  }
  function readmultifiles2(files) {
    var reader = new FileReader();
    var file = files[0];
    reader.readAsDataURL(file);
    reader.onloadend = function(e) {
      var imageUrl = e.target.result;
      $('#preview_0')
        .find($('.add-portfolio-thumbnail__preview-empty'))
        .addClass('add-portfolio-thumbnail__preview-empty--show')
        .addClass('lazyloaded')
        .attr('src', imageUrl)
        .attr('data-lazy-src', imageUrl);
    };
  }
  $(document).on('click', '.add-portfolio-thumbnail__preview-wrap', function() {
    $(this)
      .parent()
      .find('.add-portfolio-thumbnail__input')
      .trigger('click');
  });

  $(document).on(
    'click',
    '.add-portfolio__trigger, .add-portfolio-gallery__preview-wrap',
    function() {
      $(this)
        .parent()
        .find('.add-portfolio__input')
        .trigger('click');
    }
  );

  $(document).on(
    'dragenter dragover dragleave',
    '.add-portfolio__trigger',
    function(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  );
  /* eslint-enable */
  $(document).on('drop', '.add-portfolio__trigger', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var fileInput = $(this).next('input');
    var files = e.originalEvent.dataTransfer.files;
    fileInput[0].files = files;
    var that = $(this);
    filePreview(files, that);
  });
  /* eslint-disable */
  $(document).on('change', '.add-portfolio__input', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var input = $(this);
    var this_name = $(this).prop('id');
    var hidden_name = 'image_update_' + this_name;
    $('#' + hidden_name).val(1);
    try {
      var files = input[0].files;
      var that = $(this);
      filePreview(files, that);
    } catch (err) {
      $(this)
        .parent()
        .find('.add-product-gallery__preview-empty--show')
        .attr(
          'src',
          "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%3E%3C/svg%3E"
        )
        .attr(
          'data-lazy-src',
          'http://mvp.designstudio.host/wp-content/themes/designstudio-mvp/assets/images/upload.svg'
        )
        .removeClass('lazyloaded')
        .removeClass('add-product-gallery__preview-empty--show');
      $(this)
        .prev()
        .show();
    }
  });

  /* eslint-disable */
  $(document).on(
    'click',
    '.add-blog__trigger, .add-blog-gallery__preview-wrap',
    function() {
      $(this)
        .parent()
        .find('.add-blog__input')
        .trigger('click');
    }
  );
  $(document).on('dragenter dragover dragleave', '.add-blog__trigger', function(
    event
  ) {
    event.preventDefault();
    event.stopPropagation();
  });
  /* eslint-enable */
  $(document).on('drop', '.add-blog__trigger', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var fileInput = $(this).next('input');
    var files = e.originalEvent.dataTransfer.files;
    fileInput[0].files = files;
    var that = $(this);
    filePreview(files, that);
  });
  /* eslint-disable */
  $(document).on('change', '.add-blog__input', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var input = $(this);
    var this_name = $(this).prop('id');
    var hidden_name = 'image_update_' + this_name;
    $('#' + hidden_name).val(1);
    try {
      var files = input[0].files;
      var that = $(this);
      filePreview(files, that);
    } catch (err) {
      $(this)
        .parent()
        .find('.add-product-gallery__preview-empty--show')
        .attr(
          'src',
          "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%3E%3C/svg%3E"
        )
        .attr(
          'data-lazy-src',
          'http://mvp.designstudio.host/wp-content/themes/designstudio-mvp/assets/images/upload.svg'
        )
        .removeClass('lazyloaded')
        .removeClass('add-product-gallery__preview-empty--show');
      $(this)
        .prev()
        .show();
    }
  });
  /* eslint-enable */
  function filePreview(files, that) {
    var reader = new FileReader();
    var file = files[0];
    reader.readAsDataURL(file);
    reader.onloadend = function(e) {
      var imageUrl = e.target.result;
      that
        .parent()
        .find($('.add-product-gallery__preview-empty'))
        .addClass('add-product-gallery__preview-empty--show')
        .addClass('lazyloaded')
        .attr('src', imageUrl)
        .attr('data-lazy-src', imageUrl);
    };
    that
      .parent()
      .find('.acc-upload-image.add-blog__trigger')
      .hide();
    that
      .parent()
      .find('.acc-upload-image.add-portfolio__trigger')
      .hide();
    that
      .parent()
      .find('.acc-upload-image.add-portfolio-thumbnail__trigger')
      .hide();
  }

  // var tabTitle = $('#tab_title'),
  //   tabContent = $('#tab_content'),
  var tabTemplate =
      "<li><a href='#{href}'>#{label}</a> <span class='ui-icon ui-icon-close' role='presentation'>Remove Tab</span></li>",
    tabCounter = 2;

  var tabs = $('#tabs').tabs();

  // Modal dialog init: custom buttons and a "close" callback resetting the form inside
  var dialog = $('#dialog').dialog({
    autoOpen: false,
    modal: true,
    buttons: {
      Add: function() {
        addTab();
        $(this).dialog('close');
      },
      Cancel: function() {
        $(this).dialog('close');
      },
    },
    close: function() {
      form[0].reset();
    },
  });

  // AddTab form: calls addTab function on submit and closes the dialog
  var form = dialog.find('form').on('submit', function(event) {
    addTab();
    dialog.dialog('close');
    event.preventDefault();
  });

  // Actual addTab function: adds new tab using the input from the form above
  function addTab() {
    // var label = tabTitle.val() || 'Tab ' + tabCounter,
    var label = '<input type="text" name="tab-title-' + tabCounter + '" placeholder="Edit title" />',
      id = 'tabs-' + tabCounter,
      li = $(
        tabTemplate
          .replace(/#\{href\}/g, '#' + id)
          .replace(/#\{label\}/g, label)
      ),
      // tabContentHtml = tabContent.val() || 'Tab ' + tabCounter + ' content.';
      tabContentHtml =
        '<textarea class="tab-product-desc" name="tab-product-desc-' +
        tabCounter +
        '"\n' +
        '                                                      id="tab-product-desc-' +
        tabCounter +
        '" cols="30" rows="10"\n' +
        '                                                      placeholder="Tell us a bit about this product..."></textarea>';

    tabs.find('.ui-tabs-nav').append(li);
    tabs.append("<div id='" + id + "'><p>" + tabContentHtml + '</p></div>');
    productTabArea('tab-product-desc-' + tabCounter);
    tabs.tabs('refresh');
    tabCounter++;
  }

  // AddTab button: just opens the dialog
  $('#add_tab')
    .button()
    .on('click', function(e) {
      //disable default
      e.preventDefault();

      // dialog.dialog('open');
      if ($('.add-product-details .ui-tabs-tab').length < 3) {
        addTab();
      }
    });

  // Close icon: removing the tab on click
  tabs.on('click', 'span.ui-icon-close', function(e) {
    e.preventDefault();
    var panelId = $(this)
      .closest('li')
      .remove()
      .attr('aria-controls');
    $('#' + panelId).remove();
    tabs.tabs('refresh');
  });

  tabs.on('keyup', function(event) {
    if (event.altKey && event.keyCode === $.ui.keyCode.BACKSPACE) {
      var panelId = tabs
        .find('.ui-tabs-active')
        .remove()
        .attr('aria-controls');
      $('#' + panelId).remove();
      tabs.tabs('refresh');
    }
  });

  $('#control .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    $('.sidebar-popup').fadeOut();
    var url = window.location.href;
    window.location.replace(url);
  });

  $('#availability .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    // var content = wrap.find('textarea').val();
    /* eslint-disable */
    var content2 = tinymce.get('dsavailability').getContent();
    /* eslint-enable */

    var data = {
      action: 'availability',
      member_id: member_id,
      // content: content,
      content: content2,
    };

    jQuery.post(myAjax.url, data, function() {
      $('.sidebar-popup').fadeOut();
      var url = window.location.href;
      window.location.replace(url);
    });
  });

  $('#rates .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    var currency = wrap.find('#currency :selected').val();
    var hour = $('.hour_amount').val();
    var day = $('.day_amount').val();
    var week = $('.week_amount').val();
    var month = $('.month_amount').val();

    var visability = [];

    $('.rates-row').each(function() {
      if (
        $(this)
          .find('input')
          .is(':checked')
      ) {
        visability.push('true');
      } else {
        visability.push('false');
      }
    });

    var data = {
      action: 'rates',
      member_id: member_id,
      currency: currency,
      hour: hour,
      day: day,
      week: week,
      month: month,
      visability: visability,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
      $('.sidebar-popup').fadeOut();
      var url = window.location.href;
      window.location.replace(url);
    });
  });

  $('.placeholer__type a').on('click', function(e) {
    e.preventDefault();

    $('.place_default').fadeIn();
    $('.placeholer__type li').removeClass('active');
    $(this)
      .closest('li')
      .addClass('active');

    // var wrap = $(this).closest('.sidebar-popup');
    /* eslint-disable */
    if ($(this).data('placeholder') === 1) {
      // if (tinymce.get('bio').getContent() == '') {
        $('.mce-tinymce iframe')
        .contents()
        .find('#imThePlaceholder')
        .remove();
      tinymce
        .get('bio')
        .setContent(
          "<p id='imThePlaceholder'>______________is an experienced____________. Driven by ___________ he/she takes pride in providing the best ___________ posible. His/Her goals include _____________ and _____________.</p>"
        );
    } else if ($(this).data('placeholder') === 2) {
      // if (tinymce.get('bio').getContent() == '') {
      $('.mce-tinymce iframe')
        .contents()
        .find('#imThePlaceholder')
        .remove();
      tinymce
        .get('bio')
        .setContent(
          "<p id='imThePlaceholder'>After earning my degree in ______________ from _______________. I entered the _________________ world to explore my passion for _____________ and ___________.</p>"
        );
      // }
    } else if ($(this).data('placeholder') === 3) {
      // if (tinymce.get('bio').getContent() == '') {
      $('.mce-tinymce iframe')
        .contents()
        .find('#imThePlaceholder')
        .remove();
      tinymce
        .get('bio')
        .setContent(
          "<p id='imThePlaceholder'>My educational background includes a MA in _____________ and a ____________ from ______________ in ____________. I have a B.A. in _____________ from ________________ , a graduate certificate in _______________ from the _______________.</p>"
        );
      // }
    } else if ($(this).data('placeholder') === 4) {
      // if (tinymce.get('bio').getContent() == '') {
      $('iframe')
        .contents()
        .find('#imThePlaceholder')
        .remove();
      tinymce
        .get('bio')
        .setContent(
          "<p id='imThePlaceholder'>•Photographer, creative director, speaker,  and author.<br />•Layered by outdoor, travel, adventure, surf, and lifestyle subjects<br />•Through social media _________ strives to share his vision of wild places with millions of people.<br />•At the age 30, _______________ has established himself as a global presence and influencer.</p>"
        );
      // }
    }
    /* eslint-enable */
  });

  $('.acc-upload-portfolio').on('click', function() {
    $('.uploaded-images').fadeIn();
  });

  $('.upload-anumated input').on('change', function() {
    $('.acc-upload-animate').toggle();
  });

  $('.place_default').on('click', function(e) {
    e.preventDefault();

    var old_bio = $('.member-bio').html();
    $(this).fadeOut();
    $('.placeholer__type li').removeClass('active');
    /* eslint-disable */

    $('.mce-tinymce iframe')
      .contents()
      .find('#imThePlaceholder')
      .remove();
    if (old_bio == '') {
      tinymce
        .get('bio')
        .setContent(
          "<p id='imThePlaceholder'>Start typing here a brief description about yourself.</p>"
        );
    } else {
      tinymce.get('bio').setContent(old_bio);
    }
    $('.mce-tinymce iframe')
      .contents()
      .find('#imThePlaceholder')
      .css({
        color: '#a0aec0',
        'font-size': '20px',
        'font-family': '"Roboto" , sans-serif',
      });

    /* eslint-enable */
  });

  $('#bio_popup .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    // var content = wrap.find('textarea').val();
    /* eslint-disable */
    var content2 = tinymce.get('bio').getContent();
    /* eslint-enable */

    var data = {
      action: 'bio',
      member_id: member_id,
      // content: content,
      content: content2,
    };

    jQuery.post(myAjax.url, data, function() {
      $('.sidebar-popup').fadeOut();
      var url = window.location.href;
      console.log(url);
      window.location.replace(url);
      $('body, html').css('overflow', 'auto');
    });
  });

  $('.hide-input').on('change', function() {
    $(this)
      .closest('.rates-row')
      .find('.amount')
      .toggleClass('hide');
  });

  $('.hide-website').on('change', function() {
    $(this)
      .closest('.sidebar-popup__edit')
      .find('.info-bool-website')
      .toggleClass('hide');
  });

  selectRefresh();

  $(document).on('click', '.social-row__plus, .ajax-btn-plus', function(e) {
    e.preventDefault();

    var wrap = $('.ajax-social');
    $('.social-row__plus').hide();
    $('.social-row__minus').removeClass('hide');
    $('.ajax-btn-plus').removeClass('hide');
    var social_row =
      '<div class="grid-x grid-margin-x grid-margin-y social-row__item">\n' +
      '                    <div class="cell large-4">\n' +
      '                        <select class="social-list-select">\n' +
      '                            <option value="">Select one</option>\n' +
      '                            <option value="behance"><i class="fab fa-behance-square"></i>Behance</option>\n' +
      '                            <option value="dribbble"><i class="fab fa-dribbble-square"></i>Dribble</option>\n' +
      '                            <option value="facebook-f"><i class="fab fa-facebook-square"></i>Facebook</option>\n' +
      '                            <option value="flickr"><i class="fab fa-flickr"></i>Flickr</option>\n' +
      '                            <option value="instagram"><i class="fab fa-instagram"></i>Instagram</option>\n' +
      '                            <option value="linkedin-in"><i class="fab fa-linkedin"></i>LinkedIn</option>\n' +
      '                            <option value="pinterest-p"><i class="fab fa-pinterest"></i>Pinterest</option>\n' +
      '                            <option value="soundcloud"><i class="fab fa-soundcloud"></i>Soundcloud</option>\n' +
      '                            <option value="twitter"><i class="fab fa-twitter-square"></i>Twitter</option>\n' +
      '                            <option value="vimeo-v"><i class="fab fa-vimeo"></i>Vimeo</option>\n' +
      '                            <option value="youtube"><i class="fab fa-youtube"></i>Youtube</option>\n' +
      '                        </select>\n' +
      '                    </div>\n' +
      '                    <div class="cell large-8">\n' +
      '                        <div class="social-row">\n' +
      '                            <input type="text" placeholder="Eg. https://behance.net/YourName"/>\n' +
      '                            <a href="#" class="social-row__minus add-row bg-cover"></a>\n' +
      // '                            <a href="#" class="social-row__plus add-row bg-cover"></a>\n' +
      '                        </div>\n' +
      '                    </div>\n' +
      '                </div>';

    wrap.append(social_row);
    selectRefresh();
  });

  $(document).on('click', '.social-row__minus', function(e) {
    e.preventDefault();

    $(this)
      .closest('.social-row__item')
      .remove();
    // var wrap = $('.ajax-social');
  });

  $('#social .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();
    console.log('lets go');
    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    var web = $('.website').val();
    var social = [];
    $(document)
      .find('.ajax-social .social-row__item')
      .each(function(i) {
        var title = $(this)
          .find('.social-list-select option:selected')
          .val();
        var link = $(this)
          .find('.social-row input')
          .val();
        social[i] = {
          title: title,
          link: link,
        };
      });

    var data = {
      action: 'social',
      member_id: member_id,
      web: web,
      social: social,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.sidebar-popup').fadeOut();
      console.log(response);
     window.location.reload();
    });
  });

  $('#history .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var create = false;
    var edit = false;

    var wrap_b = $('.edit-work');
    var wrap = $(this).closest('.sidebar-popup');
    var wrap_create = $(this)
      .closest('.sidebar-popup')
      .find('.create-work');
    var member_id = wrap.attr('data-member-id');
    var index = wrap_b.attr('data-row');

    if (wrap_b.hasClass('active')) {
      edit = true;
    }

    if ($('.create-work').hasClass('active')) {
      create = true;
    }


    if(create){
    var position = wrap_create.find('#position').val();
    var employment = wrap_create.find('#employment :selected').val();
    var company = wrap_create.find('#company').val();
    var company_website = wrap_create.find('#company_website').val();
    var location = wrap_create.find('#location').val();
    var start = wrap_create.find('#start').val();
    var end = wrap_create.find('#end').val();
   if (wrap_create.find('#here').is(':checked')) {
      var here = 1;
    } else {
      var here = 0;
    }

    var content = wrap_create.find('#content').val();

    // var end = changeDateFormat(end);

    // var start = changeDateFormat(start);


    // var content = wrap.find('#content').val();
    // var content = wrap.find('textarea').val();
    /* eslint-disable */
    //check if tinymce.get() is undefined
    //check if .getContent exits in tinymce



      var achievements = tinymce.get('content').getContent();
    
    
    /* eslint-enable */
    } else {
    var edit_position = wrap_b.find('#edit-position').val();
    var edit_type = wrap_b.find('#edit-employment :selected').val();
    var edit_company = wrap_b.find('#edit-company').val();
    var edit_company_website = wrap_b.find('#edit-company-website').val();
    var edit_location = wrap_b.find('#edit-location').val();
    var edit_start = wrap_b.find('#edit-start').val();
    var edit_end = wrap_b.find('#edit-end').val();

    //if checkbox is checked edit-here
    if (wrap_b.find('#edit-here').is(':checked')) {
      var edit_here = 1;
    } else {
      var edit_here = 0;
    }
    /* eslint-disable */
    if (!empty(achievements)) {
      var edit_achievements = tinymce.get('edit-content').getContent();
    }
   
    /* eslint-enable */

    // edit_start = changeDateFormat(edit_start);

    // edit_end = changeDateFormat(edit_end);


    var edit_data = [{'position': edit_position, 'type': edit_type, 'company': edit_company, 'company_website': edit_company_website, 'location': edit_location, 'start': edit_start, 'end': edit_end, 'achievements': edit_achievements, 'here': edit_here}];
  }

    var new_order = [];

    $('.work-list .edit-existing').each(function() {
      var id = $(this).attr('data-row');
      new_order.push(id);
    });


    var data = {
      action: 'history',
      member_id: member_id,
      position: position,
      employment: employment,
      company: company,
      company_website: company_website,
      location: location,
      start: start,
      end: end,
      here: here,
      achievements: achievements,
      edit_data: edit_data,
      create: create,
      edit: edit,
      index: index,
      new_order: new_order
    };
  
    jQuery.post(myAjax.url, data, function() {
         $('.sidebar-popup').fadeOut();
         window.location.reload();
      $('body, html').css('overflow', 'auto');
    });
  });


  
  $('#education .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var create = false;
    var edit = false;

    var wrap_b = $('.edit-school');
    var wrap = $(this).closest('.sidebar-popup');
    var wrap_create = $(this)
      .closest('.sidebar-popup')
      .find('.create-school');
    var member_id = wrap.attr('data-member-id');
    var index = wrap_b.attr('data-row');

    if (wrap_b.hasClass('active')) {
      edit = true;
    }

    if ($('.create-school').hasClass('active')) {
      create = true;
    }

    var school = wrap_create.find('#school').val();
    var study = wrap_create.find('#study').val();
    var start = wrap_create.find('#start_year').val();
    var end = wrap_create.find('#end_year').val();
    var achievements = wrap_create.find('#achievements').val();
    var qualification = wrap_create.find('#qualification').val();

    var title = wrap_b.find('#school').val();
    var subtitle = wrap_b.find('#study').val();

    var start_y = wrap_b.find('#start_year').val();
    var end_y = wrap_b.find('#end_year').val();
    var content = wrap_b.find('#achievements').val();
    var qualification_b = wrap_b.find('#qualification').val();

    var edit_data = [];
    edit_data.push(title);
    edit_data.push(subtitle);
    edit_data.push(start_y);
    edit_data.push(end_y);
    edit_data.push(content);
    edit_data.push(qualification_b);


    var new_order = [];

    $('.school-list .edit-existing').each(function() {
      var id = $(this).attr('data-row');
      new_order.push(id);
    });


    var data = {
      action: 'education',
      member_id: member_id,
      school: school,
      qualification: qualification,
      study: study,
      start: start,
      end: end,
      achievements: achievements,
      edit_data: edit_data,

      create: create,
      edit: edit,
      index: index,
      new_order: new_order
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
       $('.sidebar-popup').fadeOut();
       window.location.reload();
      $('body, html').css('overflow', 'auto');
    });
  });

  $('.slide-percentage-inner').slider({
    range: 'min',
    value: 0,
    min: 0,
    max: 100,
    slide: function(event, ui) {
      $(this)
        .closest('.slide-percentage')
        .find('.text-count')
        .text(ui.value + '%');
      $(this)
        .closest('.slide-percentage')
        .find('.text-count-hide')
        .val(ui.value);
    },
  });

  $('.burger').on('click', function(e) {
    e.preventDefault();

    $(this)
      .closest('.edit-existing')
      .find('ul li')
      .each(function(i) {
        if (i > 1) {
          $(this).toggleClass('hide');
        }
      });
  });

  $('.edit-skills-plus').on('click', function(e) {
    e.preventDefault();
    //get data row
    var row = $(this).attr('data-row');
    //get edit-existing_tools with same data row
    var wrap = $('.edit-existing[data-row="' + row + '"] .edit-existing__tools ul');
   
    // var wrap = $('.edit-existing__tools ul');
    var skill =
    `
    <li class="edit-existing__item hide">
    <span class="skill-title"></span>
    <span class="percentage"><span class="percentage__inner"
                                   style=""></span></span>
    </li>

    <div class="create-tool__item edit-clone-row">
    <input type="text" placeholder="Eg. Adobe Photoshop"
           value=""/>
    <div class="slide-percentage"
         data-percent="">
        <span class="slide-percentage-inner"></span>
        <p class="text-count">0%</p>
        <input type="hidden" class="text-count-hide"
               value=""/>
    </div>
</div>
`;

    wrap.append(skill);
    $('.slide-percentage-inner').slider({
      range: 'min',
      // value: 0,
      min: 0,
      max: 100,
      slide: function(event, ui) {
        $(this)
          .closest('.slide-percentage')
          .find('.text-count')
          .text(ui.value + '%');
        $(this)
          .closest('.slide-percentage')
          .find('.text-count-hide')
          .val(ui.value);
      },
    });
  });


  $('.skills-plus').on('click', function(e) {
    e.preventDefault();

    var wrap = $('.create-skills');
    var skill =
      '<div class="create-tool__item">\n' +
      '                                    <input type="text" placeholder="Eg. Adobe Photoshop"/>\n' +
      '                                    <div class="slide-percentage">\n' +
      '                                        <span class="slide-percentage-inner"></span>\n' +
      '                                        <p class="text-count">0%</p>\n' +
      '                                        <input type="hidden" class="text-count-hide"/>\n' +
      '                                    </div>\n' +
      '                                </div>';

    wrap.append(skill);
    $('.slide-percentage-inner').slider({
      range: 'min',
      // value: 0,
      min: 0,
      max: 100,
      slide: function(event, ui) {
        $(this)
          .closest('.slide-percentage')
          .find('.text-count')
          .text(ui.value + '%');
        $(this)
          .closest('.slide-percentage')
          .find('.text-count-hide')
          .val(ui.value);
      },
    });
  });

  $('#skills .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    var create = [];
    var create_title = $('.create-tool__title')
      .next('input')
      .val();

    $('.create-skills .create-tool__item').each(function(i) {
      var title = $(this)
        .find('input')
        .val();
      var value = $(this)
        .find('.text-count-hide')
        .val();
      create[i] = {
        skill: title,
        skill_percent: value,
      };
    });

    var new_order = [];

    $('.skills-area .skills-list .edit-existing').each(function() {
      var id = $(this).attr('data-row');
      new_order.push(id);
    });

    var data = {
      action: 'skills',
      member_id: member_id,
      title: create_title,
      skills: create,
      new_order: new_order,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.sidebar-popup').fadeOut();
      window.location.reload();
      $('body, html').css('overflow', 'auto');
    });
  });

  $('.skills-list .edit-existing__icons-panel .ds-delete').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    var wrap_item = $(this).closest('.edit-existing');
    var index = wrap_item.attr('data-row');
    var data = {
        action: 'removeSkills',
        index: index,
        member_id: member_id,
    };

    new Swal({
        title: 'Are you sure?',
        text: "It will permanently be deleted!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef6d00',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function(results) {
        //   console.log(results);
          if(results.isConfirmed) {
            new Swal(
                'Deleted!',
                'Your skill set has been deleted.',
                'success'
              );
                jQuery.post(myAjax.url, data, function() {
                  $('.sidebar-popup').fadeOut();
                  $('body, html').css('overflow', 'auto');
                  //reload page
                    window.location.reload();
                }); 

          } else if (results.isDismissed) {
            new Swal(
                'Cancelled',
                'Your skill set is safe :)',
                'error'
              );
          }
      })


  });

  $('.school-list .edit-existing__icons-panel .ds-delete').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    var wrap_item = $(this).closest('.edit-existing');
    var index = wrap_item.attr('data-row');

    var data = {
      action: 'removeEducation',
      index: index,
      member_id: member_id,
    };


    new Swal({
        title: 'Are you sure?',
        text: "It will permanently be deleted!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef6d00',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function(results) {
        //   console.log(results);
          if(results.isConfirmed) {
            new Swal(
                'Deleted!',
                'Your education data has been deleted.',
                'success'
              );
              jQuery.post(myAjax.url, data, function(response) {
                console.log(response);
                $('.sidebar-popup').fadeOut();
                window.location.reload();
                $('body, html').css('overflow', 'auto');
              });

          } else if (results.isDismissed) {
            new Swal(
                'Cancelled',
                'Your education data is safe :)',
                'error'
              );
          }
      })



    
  });

  $('.edit-work .go-back').on('click', function(e) {
    console.log('go back dude');
    e.preventDefault();
    $('.sidebar-popup').fadeOut();
    window.location.reload();
    $('body, html').css('overflow', 'auto');
  });

  $('.edit-existing__icons-edit .edit').on('click', function(e) {
    e.preventDefault();

    // $(this)
    //   .closest('.edit-existing')
    //   .find('ul li')
    //   .each(function(i) {
    //     if (i > 1) {
    //       $(this).toggleClass('hide');
    //     }
    //   });

    $(this)
      .closest('.edit-existing')
      .find('ul li')
      .addClass('hide');

    $(this)
      .closest('.edit-existing')
      .find('.edit-existing__item')
      .each(function() {
        $(this).addClass('hide');
      });
  $(this)
      .closest('.edit-existing')
      .find('.edit-skills-plus')
      .each(function() {
        $(this).removeClass('hide');
      });

    $(this)
      .closest('.edit-existing')
      .find('.edit-clone-row')
      .each(function() {
        $(this).removeClass('hide');
        var value = $(this)
          .find('.slide-percentage')
          .attr('data-percent');
        $(this)
          .find('.slide-percentage-inner')
          .slider({
            range: 'min',
            value: value,
            min: 0,
            max: 100,
            slide: function(event, ui) {
              $(this)
                .closest('.slide-percentage')
                .find('.text-count')
                .text(ui.value + '%');
              $(this)
                .closest('.slide-percentage')
                .find('.text-count-hide')
                .val(ui.value);
            },
          });
      });

    $(this).toggleClass('hide');
    $(this)
      .next('.save')
      .toggleClass('hide');
  });

  $('.edit-existing__icons-edit .save').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('hide');
    $(this)
      .next('.save')
      .toggleClass('hide');

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    var wrap_item = $(this).closest('.edit-existing');
    var index = wrap_item.attr('data-row');
    index = parseInt(index);
    var edit_skills = [];
    var new_order = [];
    //window.location.reload();

    $('.skills-area .skills-list .edit-existing').each(function() {
      var id = $(this).attr('data-row');
      new_order.push(id);
    });

    wrap_item.find('.edit-clone-row').each(function(i) {
      edit_skills[i] = {
        skill: $(this)
          .find('input')
          .val(),
        skill_percent: $(this)
          .find('.text-count-hide')
          .val(),
      };
    });

    var data = {
      action: 'editSkills',
      index: index,
      member_id: member_id,
      edit_skills: edit_skills,
      new_order: new_order,
    };

    jQuery.post(myAjax.url, data, function(response) {
      $('.sidebar-popup').fadeOut();
      console.log(response);
      window.location.reload();
      $('body, html').css('overflow-y', 'auto');
    });
  });

  /* eslint-disable */
  tinymce.init({
    mode: 'exact',
    elements: 'dsavailability',
    height: '350',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist link'],
    // plugins: 'paste',
    max_chars: 250,
    plugins: 'lists link paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        var old_ava = $('.member-availability').html();
        var old_bio = $('.member-bio').html();
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#edf2f7',
            padding: '5px 20px',
            margin: 0,
          });
        if (tinymce.get('dsavailability').getContent() == '' && old_ava == '') {
          tinymce
            .get('dsavailability')
            .setContent(
              "<p id='imThePlaceholder'>Start typing here what is your availability</p>"
            );
        } else {

          tinymce.get('dsavailability').setContent(old_ava);
        }
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
      editor.on('focus', function() {
        $('iframe')
          .contents()
          .find('#imThePlaceholder')
          .remove();
      });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });
  tinymce.init({
    mode: 'exact',
    elements: 'bio',
    height: '350',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist link'],
    // plugins: 'paste',
    max_chars: 500,
    plugins: 'lists link paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        var old_ava = $('.member-availability').html();
        var old_bio = $('.member-bio').html();
        console.log(old_bio);
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#edf2f7',
            padding: '5px 20px',
            margin: 0,
          });
        if (tinymce.get('bio').getContent() == '' && old_bio == '') {
          tinymce
            .get('bio')
            .setContent(
              "<p id='imThePlaceholder2'>Start typing here a brief description about yourself.</p>"
            );
        } else {
          tinymce.get('bio').setContent(old_bio);
        }
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
      editor.on('focus', function() {
        $('iframe')
          .contents()
          .find('#imThePlaceholder2')
          .remove();
      });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });
  tinymce.init({
    mode: 'exact',
    elements: 'content,edit-content',
    height: '350',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist link'],
    // plugins: 'paste',
    max_chars: 100,
    plugins: 'lists link paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        var old_ava = $('.member-availability').html();
        var old_bio = $('.member-bio').html();
        // console.log(old_bio);
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#edf2f7',
            padding: '5px 20px',
            margin: 0,
          });
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
    //   editor.on('focus', function() {
    //     $('iframe')
    //       .contents()
    //       .find('#imThePlaceholder')
    //       .remove();
    //   });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters per achievement.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });
  // tinymce.init({
  //   mode: 'exact',
  //   elements: 'content,edit-content',
  //   height: '350',
  //   menubar: false,
  //   statusbar: false,
  //   toolbar: ['bold italic bullist'],
  //   // plugins: 'paste',
  //   max_chars: 100,
  //   plugins: 'lists',
  //   paste_auto_cleanup_on_paste: true,
  //   paste_postprocess: function(pl, o) {
  //     o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
  //   },
  //   setup: function(editor) {
  //     editor.on('init', function() {
  //       var old_ava = $('.member-availability').html();
  //       var old_bio = $('.member-bio').html();
  //       console.log(old_bio);
  //       $('.mce-tinymce iframe')
  //         .contents()
  //         .find('.mce-content-body')
  //         .css({
  //           'background-color': '#edf2f7',
  //           padding: '5px 20px',
  //           margin: 0,
  //         });
  //       $('.mce-tinymce iframe')
  //         .contents()
  //         .find('#imThePlaceholder')
  //         .css({
  //           color: '#a0aec0',
  //           'font-size': '20px',
  //           'font-family': '"Roboto" , sans-serif',
  //         });
  //     });
  //     var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
  //     editor.on('keydown', function(e) {
  //       if (allowedKeys.indexOf(e.keyCode) != -1) return true;
  //       if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
  //         e.preventDefault();
  //         e.stopPropagation();
  //         return false;
  //       }
  //       return true;
  //     });
  //     editor.on('keyup', function(e) {
  //       tinymce_updateCharCounter(this, tinymce_getContentLength());
  //     });
  //     //and remove it on focus
  //     editor.on('focus', function() {
  //       $('iframe')
  //         .contents()
  //         .find('#imThePlaceholder')
  //         .remove();
  //     });
  //   },
  //   init_instance_callback: function() {
  //     // initialize counter div
  //     $('#' + this.id)
  //       .prev()
  //       .append('<div class="char_count" style="text-align:right"></div>');
  //     tinymce_updateCharCounter(this, tinymce_getContentLength());
  //   },
  //   paste_preprocess: function(plugin, args) {
  //     var editor = tinymce.get(tinymce.activeEditor.id);
  //     var len = editor.contentDocument.body.innerText.length;
  //     var text = $(args.content).text();
  //     if (len + text.length > editor.settings.max_chars) {
  //       alert(
  //         'Pasting this exceeds the maximum allowed number of ' +
  //         editor.settings.max_chars +
  //         ' Characters per achievement.'
  //       );
  //       args.content = '';
  //     } else {
  //       tinymce_updateCharCounter(editor, len + text.length);
  //     }
  //   },
  // });
  tinymce.init({
    mode: 'exact',
    elements: 'add-product-desc, hello',
    height: '190',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist link'],
    // plugins: 'paste',
    max_chars: 100,
    plugins: 'lists link paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        var old_ava = $('.member-availability').html();
        var old_bio = $('.member-bio').html();
        // console.log(old_bio);
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#edf2f7',
            padding: '5px 20px',
            margin: 0,
            'border-radius': '6px',
          });
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
    //   editor.on('focus', function() {
    //     $('iframe')
    //       .contents()
    //       .find('#imThePlaceholder')
    //       .remove();
    //   });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters per achievement.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });

  $('#unconnect-btn').on('click', function(e) {
    e.preventDefault();
    if(this.dataset.author_id) {
        let authorID = this.dataset.author_id;
        
        $.ajax({
            url: myAjax.url,
            data: {
              action: 'delete_connect',
              authorID: authorID,
            },
            type: 'POST',
            error: function(xhr, textStatus, error) {
              console.log(xhr.statusText);
              console.log(textStatus);
              console.log(error);
            },
            //get the results
    
            success: function(data) {
              console.log('deleted');
              
              $('body, html').css('overflow-y', 'inherit');
              $('.sidebar-popup').fadeOut();
               window.location.reload();
            },
          });
        }
  });

  $('#connect-btn').on('click', function(e) {
    e.preventDefault();
    console.log('hello');
    if (this.dataset.author_id) {
      let authorID = this.dataset.author_id;

      $.ajax({
        url: myAjax.url,
        data: {
          action: 'new_connect',
          authorID: authorID,
        },
        type: 'POST',
        error: function(xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          console.log(error);
        },
        //get the results

        success: function(data) {
          console.log('added');
          
          $('body, html').css('overflow-y', 'inherit');
          $('.sidebar-popup').fadeOut();
           window.location.reload();
        },
      });
    }
  });
  
  tinymce.init({
    mode: 'exact',
    elements: 'message-area',
    height: '225',
    menubar: false,
    statusbar: false,
    // toolbar: ['bold italic bullist'],
    toolbar:
      'undo redo styleselect bold italic bullist numlist outdent indent image charmap hr link',
    // plugins: 'paste',
    // max_chars: 500,
    // plugins: 'lists link image code emoticons hr charmap table',
    plugins: 'lists link paste',
    paste_as_text: true,
    theme_advanced_toolbar_location: 'bottom',
    // content_css: [''],

    setup: function(editor) {
      editor.on('keyup', function(e) {
       
        if (e.keyCode == 13 && !e.shiftKey) $('.send-area').click();
      });

      editor.on('click', function(e) {
        if (tinymce.get('message-area').getContent() == '<p id="imThePlaceholder" style="color: #a0aec0; font-size: 20px; font-family: Roboto, sans-serif;">Type a message here</p>')
            $('.mce-tinymce iframe').contents().find('.mce-content-body').html ('<p><br /></p>');
      });

      editor.on('init', function() {
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#fff',
            padding: '5px 20px',
            'font-size': '20px',
            color: '#707070',
            margin: 0,
            border: 0,
          });
        if (tinymce.get('message-area').getContent() == '') {
          tinymce
            .get('message-area')
            .setContent("<p id='imThePlaceholder'>Type a message here</p>");
        }

        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });

      //   editor.on('focus', function() {
      //     $('.send-area').addClass('active');
      //   });
    },
  });

  //   $('.send-area').on('click', function(e) {
  //     e.preventDefault();
  //     $(this).removeClass('active');
  //   });

  tinymce.init({
    mode: 'exact',
    elements: 'order-comments-area',
    height: '225',
    menubar: false,
    statusbar: false,
    toolbar:
      'undo redo styleselect bold italic bullist numlist outdent indent image charmap hr link',
    plugins: 'lists link paste',
    paste_as_text: true,
    theme_advanced_toolbar_location: 'bottom',
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      // editor.on('keyup', function(e) {
      //     console.log('Editor contents was modified. Contents: ' + ed.getContent());

      // });
      editor.on('init', function() {
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            color: '#a7a7a7',
            'font-size': '18px',
            'font-family': '"Roboto" , sans-serif',
            'background-color': '#fff',
            padding: '5px 20px 60px',
            margin: 0,
            border: 0,
          });
        if (tinymce.get('order-comments-area').getContent() == '') {
          tinymce
            .get('order-comments-area')
            .setContent("<p id='imThePlaceholder'>Type a message here</p>");
        }
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a7a7a7',
            'font-size': '20px',
          });
      });

      editor.on('focus', function() {
        $('.send-area').addClass('active');
        $('iframe')
          .contents()
          .find('#imThePlaceholder')
          .remove();
      });
    },
  });

  tinymce.init({
    mode: 'exact',
    elements: 'product-tab-area',
    height: '300',
    menubar: false,
    statusbar: false,
    toolbar: [
      'undo redo styleselect bold italic bullist numlist outdent indent link image charmap hr blockquote',
    ],
    // plugins: 'paste',
    max_chars: 1200,
    plugins: 'lists paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'background-color': '#fff',
            padding: '15px 20px',
            margin: 0,
          });

        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
            'margin-top': 0,
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
      editor.on('focus', function() {
        $('iframe')
          .contents()
          .find('#imThePlaceholder')
          .remove();
      });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLengthProduct());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters per achievement.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });

  function productTabArea(field_id) {
    tinymce.init({
      mode: 'exact',
      elements: field_id,
      height: '300',
      menubar: false,
      statusbar: false,
      toolbar: [
        'undo redo styleselect bold italic bullist numlist outdent indent link image charmap hr blockquote',
      ],
      // plugins: 'paste',
      max_chars: 1200,
      plugins: 'lists paste',
      paste_as_text: true,
      paste_auto_cleanup_on_paste: true,
      paste_postprocess: function(pl, o) {
        o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
      },
      setup: function(editor) {
        editor.on('init', function() {
          $('.mce-tinymce iframe')
            .contents()
            .find('.mce-content-body')
            .css({
              'background-color': '#fff',
              padding: '15px 20px',
              margin: 0,
            });
          if (tinymce.get('product-tab-area').getContent() == '') {
            tinymce
              .get('product-tab-area')
              .setContent(
                "<p id='imThePlaceholder'>An optional long description for your item can go here.</p>"
              );
          }
          $('.mce-tinymce iframe')
            .contents()
            .find('#imThePlaceholder')
            .css({
              color: '#a0aec0',
              'font-size': '20px',
              'font-family': '"Roboto" , sans-serif',
              'margin-top': 0,
            });
        });
        var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
        editor.on('keydown', function(e) {
          if (allowedKeys.indexOf(e.keyCode) != -1) return true;
          if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
          return true;
        });
        editor.on('keyup', function(e) {
          tinymce_updateCharCounter(this, tinymce_getContentLength());
        });
        //and remove it on focus
        editor.on('focus', function() {
          $('iframe')
            .contents()
            .find('#imThePlaceholder')
            .remove();
        });
      },
      init_instance_callback: function() {
        // initialize counter div
        $('#' + this.id)
          .prev()
          .append('<div class="char_count" style="text-align:right"></div>');
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      },
      paste_preprocess: function(plugin, args) {
        var editor = tinymce.get(tinymce.activeEditor.id);
        var len = editor.contentDocument.body.innerText.length;
        var text = $(args.content).text();
        if (len + text.length > editor.settings.max_chars) {
          alert(
            'Pasting this exceeds the maximum allowed number of ' +
              editor.settings.max_chars +
              ' Characters per achievement.'
          );
          args.content = '';
        } else {
          tinymce_updateCharCounter(editor, len + text.length);
        }
      },
    });
  }

  tinymce.init({
    mode: 'exact',
    elements: 'message-accept,message-ignore',
    height: '250',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist'],
    max_chars: 200,
    plugins: 'lists paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
            'background-color': '#edf2f7',
            padding: '5px 20px',
            margin: 0,
          });
        if (tinymce.get('message-accept').getContent() == '') {
          tinymce
            .get('message-accept')
            .setContent("<p id='imThePlaceholder'>Type something…</p>");
        }
        if (tinymce.get('message-ignore').getContent() == '') {
          tinymce
            .get('message-ignore')
            .setContent("<p id='imThePlaceholder'>Type something…</p>");
        }
        $('.mce-tinymce iframe')
          .contents()
          .find('#imThePlaceholder')
          .css({
            color: '#a0aec0',
            'font-size': '20px',
            'font-family': '"Roboto" , sans-serif',
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
      //and remove it on focus
      editor.on('focus', function() {
        $('iframe')
          .contents()
          .find('#imThePlaceholder')
          .remove();
      });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters per achievement.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });

  tinymce.init({
    mode: 'exact',
    elements: 'about-project',
    height: '250',
    menubar: false,
    statusbar: false,
    toolbar: ['bold italic bullist'],
    max_chars: 300,
    plugins: 'lists paste',
    paste_as_text: true,
    paste_auto_cleanup_on_paste: true,
    paste_postprocess: function(pl, o) {
      o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;+/gi, ' ');
    },
    setup: function(editor) {
      editor.on('init', function() {
        $('.mce-tinymce iframe')
          .contents()
          .find('.mce-content-body')
          .css({
            'font-size': '18px',
            'background-color': '#edf2f7',
            padding: '0 20px',
            margin: 0,
          });
      });
      var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
      editor.on('keydown', function(e) {
        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
        if (tinymce_getContentLength() + 1 > this.settings.max_chars) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return true;
      });
      editor.on('keyup', function(e) {
        tinymce_updateCharCounter(this, tinymce_getContentLength());
      });
    },
    init_instance_callback: function() {
      // initialize counter div
      $('#' + this.id)
        .prev()
        .append('<div class="char_count" style="text-align:right"></div>');
      tinymce_updateCharCounter(this, tinymce_getContentLength());
    },
    paste_preprocess: function(plugin, args) {
      var editor = tinymce.get(tinymce.activeEditor.id);
      var len = editor.contentDocument.body.innerText.length;
      var text = $(args.content).text();
      if (len + text.length > editor.settings.max_chars) {
        alert(
          'Pasting this exceeds the maximum allowed number of ' +
            editor.settings.max_chars +
            ' Characters per achievement.'
        );
        args.content = '';
      } else {
        tinymce_updateCharCounter(editor, len + text.length);
      }
    },
  });

  /* eslint-enable */

  $('.sidebar-button .hide-input').on('change', function() {
    var btn = '';
    var value = true;
    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    var btn = $(this)
      .closest('.sidebar-button')
      .attr('data-block');
    if (btn) btn = 'tabs_' + btn;

    if ($(this).hasClass('button1')) {
      btn = 'button1';
    } else if ($(this).hasClass('button2')) {
      btn = 'button2';
    } else if ($(this).hasClass('button3')) {
      btn = 'button3';
    }

    if (
      !$(this)
        .parent()
        .find('input')
        .is(':checked')
    ) {
      value = false;
    }

    var data = {
      action: 'control_buttons',
      member_id: member_id,
      btn: btn,
      value: value,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
    });
  });

  $('.sidebar-control .hide-incognito').on('change', function() {
    var incognito = false;
    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    if ($(this).is(':checked')) {
      incognito = true;
    }

    var data = {
      action: 'incognito',
      member_id: member_id,
      incognito: incognito,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
    });
  });

  $(function() {
    $(
      '.controls-order, .skills-list, .work-list, .school-list, .tabs-order, .uploaded-list, .build-content'
    ).sortable({
      revert: true,
      update: function() {
        // console.log('update: ' + ui.item.index());
      },
    });
    $('.controls-order .sidebar-button').disableSelection();
  });

  $(function() {
    $('.billed-list').sortable({
      revert: true,
      handle: '.billed-item__move',
      update: function() {
        recountBilledProducts();
      },
    });
    $('.controls-order .sidebar-button').disableSelection();
  });

  $('#add_item').on('click', function() {
    $('.billed-item select').select2('destroy');

    let clonedItem = $('.billed-item[data-counter="1"]')
      .clone()
      .appendTo('.billed-items');
    let clonedIndex = clonedItem.index() + 1;
    clonedItem.attr('data-counter', clonedIndex);

    let clonedFields = clonedItem.find('.refreshID');

    $.each(clonedFields, function() {
      let thisId = $(this).attr('id'),
        thisIdArray = thisId.split('-1'),
        newId = thisIdArray[0] + '-' + clonedIndex;
      $(this).attr('id', newId);
    });
    clonedItem
      .find('input')
      .val('')
      .closest('.billed-item')
      .find('textarea')
      .val('')
      .closest('.billed-item')
      .find('select');

    $('.billed-item select').select2({ minimumResultsForSearch: -1 });

    recountBilledProducts();
  });

  function recountBilledProducts() {
    $('.billed-item').each(function() {
      let thisIndex = $(this).index() + 1;
      $(this)
        .find('.billed-item__counter')
        .html(thisIndex);
    });
  }

  $('.sidebar-control .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var new_order = [];
    var show_array = [];

    $('.controls-order .sidebar-button').each(function() {
      var id = $(this).attr('data-id');
      var title = $(this).attr('data-block');
      var value = 'true';
      if (
        !$(this)
          .find('input')
          .is(':checked')
      ) {
        value = 'false';
      }

      show_array.push({
        title: title,
        value: value,
      });
      new_order.push(id);
    });
    console.log(new_order);
    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    console.log(show_array);

    var data = {
      action: 'reorder',
      member_id: member_id,
      new_order: new_order,
      show_array: show_array,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
      $('.sidebar-popup').fadeOut();
      location.reload();
      $('body, html').css('overflow', 'auto');
    });
  });

  $('.add-school').on('click', function(e) {
    e.preventDefault();

    $(this).hide();
    $('.create-school')
      .addClass('active')
      .fadeIn();
  });

  $('.add-work').on('click', function(e) {
    e.preventDefault();

    $(this).hide();
    $('.create-work')
      .addClass('active')
      .fadeIn();
  });

  $('.school-list .edit').on('click', function(e) {
    e.preventDefault();

    var index = $(this)
      .closest('.edit-existing')
      .attr('data-row');
    $('.edit-existing, .add-school').hide();
    $('.edit-school')
      .addClass('active')
      .fadeIn();
    var wrap_b = $(this).closest('.edit-existing');

    var title = wrap_b
      .find('.edit-data')
      .find('.title')
      .text();
    var subtitle = wrap_b
      .find('.edit-data')
      .find('.subtitle')
      .text();

    var start = wrap_b
      .find('.edit-data')
      .find('.start')
      .text();
    var end = wrap_b
      .find('.edit-data')
      .find('.end')
      .text();
    var content = wrap_b
      .find('.edit-data')
      .find('.content')
      .text();

    var wrap = $('.edit-school');
    wrap.attr('data-row', index);
    wrap.find('#school').val(title);
    wrap.find('#study').val(subtitle);
    wrap.find('#start_year').val(start);
    wrap.find('#end_year').val(end);
    wrap.find('#achievements').val(content);
  });

  $('.work-list .edit').on('click', function(e) {
    e.preventDefault();
    var index = $(this)
      .closest('.edit-existing')
      .attr('data-row');
    $('.edit-existing, .add-work').hide();
    $('.edit-work')
      .addClass('active')
      .fadeIn();
    var wrap_b = $(this).closest('.edit-existing');

    var position = wrap_b
      .find('.edit-data')
      .find('.position')
      .text();
    var type = wrap_b
      .find('.edit-data')
      .find('.type')
      .text();
    var company = wrap_b
      .find('.edit-data')
      .find('.company')
      .text();
    var company_website = wrap_b
      .find('.edit-data')
      .find('.company_website')
      .text();
    var location = wrap_b
      .find('.edit-data')
      .find('.location')
      .text();
    var start = wrap_b
      .find('.edit-data')
      .find('.edit-start-preload')
      .val();
    var end = wrap_b
      .find('.edit-data')
      .find('.edit-end-preload')
      .val();
    var content = wrap_b
      .find('.edit-data')
      .find('.content')
      .text();

    var wrap = $('.edit-work');
    wrap.attr('data-row', index);
    wrap.find('#edit-position').val(position);
    wrap.find('#edit-type').val(type);
    wrap.find('#edit-company').val(company);
    wrap.find('#edit-company-website').val(company_website);
    wrap.find('#edit-location').val(location);
    wrap.find('#edit-start').val(start);
    wrap.find('#edit-end').val(end);
    /* eslint-disable */
    tinymce.get('edit-content').setContent(content);
    /* eslint-enable */

    if(wrap_b.find('.edit-data').find('.edit-here-preload').is(':checked')){ 
        
        wrap.find('#edit-here').prop('checked', true);
      }

});

  $('.work-list .edit-existing__icons-panel .ds-delete').on('click', function(e) {
    e.preventDefault();

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    var wrap_item = $(this).closest('.edit-existing');
    var index = wrap_item.attr('data-row');

    var data = {
      action: 'history_remove',
      index: index,
      member_id: member_id,
    };


    new Swal({
        title: 'Are you sure?',
        text: "It will permanently be deleted!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef6d00',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function(results) {
        //   console.log(results);
          if(results.isConfirmed) {
            new Swal(
                'Deleted!',
                'Your work history has been deleted.',
                'success'
              );
              jQuery.post(myAjax.url, data, function(response) {
                console.log(response);
                $('.sidebar-popup').fadeOut();
                var url = window.location.href;
                window.location.replace(url);
                $('body, html').css('overflow', 'auto');
              });
          } else if (results.isDismissed) {
            new Swal(
                'Cancelled',
                'Your work history is safe :)',
                'error'
              );
          }
      })


    
  });

  $('.table-wrap .show-content').on('click', function(e) {
    e.preventDefault();

    $(this)
      .find('.plus')
      .toggleClass('hide');
    $(this)
      .find('.minus')
      .toggleClass('hide');

    $(this)
      .closest('tr')
      .toggleClass('clicked');
    $(this)
      .closest('tr')
      .next('tr')
      .toggleClass('active');
  });

  $('.toggle-tbody').on('click', function(e) {
    e.preventDefault();
    $(this)
      .toggleClass('active')
      .closest('.table-wrap')
      .find('tbody')
      .slideToggle();
  });

  $('.content-edit').on('click', function(e) {
    e.preventDefault();

    $('.edit-nav').toggle();
  });

  $('.sidebar-tabs-edit .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var new_order = [];
    var show_array = [];

    $('.tabs-order .sidebar-button').each(function() {
      var id = $(this).attr('data-id');
      var title = $(this).attr('data-block');
      var value = 'true';
      if (
        !$(this)
          .find('input')
          .is(':checked')
      ) {
        value = 'false';
      }

      show_array.push({
        title: title,
        value: value,
      });
      new_order.push(id);
    });
    console.log(new_order);
    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');

    console.log(show_array);

    var data = {
      action: 'edit_tabs',
      member_id: member_id,
      new_order: new_order,
      show_array: show_array,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
      $('.sidebar-popup').fadeOut();
      var url = window.location.href;
      window.location.replace(url);
      $('body, html').css('overflow', 'auto');
    });
  });

  $('#editHero .hero-categories, #editHero .search__input').on(
    'change keyup',
    function() {
      var wrap = $(this).closest('.sidebar-popup');
      var member_id = wrap.attr('data-member-id');

      var category = $('#editHero .hero-categories option:selected').val();
      var search = $('#editHero .search__input').val();

      var data = {
        action: 'editHeroFilter',
        member_id: member_id,
        category: category,
        search: search,
      };

      jQuery.post(myAjax.url, data, function(response) {
        console.log(response);
        wrap = $('.ajaxHeroFilter');
        wrap.empty();
        wrap.append(response);
      });
    }
  );

  $(document).on('click', '.ajaxHeroFilter .gallery-image', function() {
    $('.ajaxHeroFilter .gallery-image').removeClass('active');
    $(this).addClass('active');
    var img = $(this).attr('data-bg');
    console.log(img);
    $('.hero-banner').css({
      background: img,
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'background-position': 'center',
    });
  });

  $(document).on('click', '.inner-solid .gallery-image', function() {
    $('.inner-solid .gallery-image').removeClass('active');
    $(this).addClass('active');
    var color = $(this).data('color');
    $('.hero-banner').css('background', color);
    $('.edit-gradient').addClass('hide');
    $('.edit-solid').removeClass('hide');
    $('.inner-solid')
      .find('input')
      .val(color);
    $('#colorPicker').val(color);
    $('#solidColor').text(color);
  });

  $(document).on('click', '.inner-gradients .gallery-image', function() {
    $('.inner-gradients .gallery-image').removeClass('active');
    $(this).addClass('active');
    var from = $(this).data('from');
    var to = $(this).data('to');
    $('.hero-banner').css({
      background: 'linear-gradient(to bottom,' + from + ', ' + to + ')',
    });
    $('.edit-solid').addClass('hide');
    $('.edit-gradient').removeClass('hide');
    $('#colorPickerFrom').val(from);
    $('#gradientFrom').text(from);
    $('#colorPickerTo').val(to);
    $('#gradientTo').text(to);
  });

  $('.sidebar-hero-edit .tabs .tabs-title').on('click', function() {
    var color = null;
    var from = null;
    var to = null;
    if ($(this).hasClass('color-tab')) {
      if ($('#solid').is(':checked')) {
        $('.sidebar-hero-edit .inner-solid .gallery-image').each(function() {
          if ($(this).hasClass('active')) {
            color = $(this).attr('data-color');
            $('.edit-solid')
              .removeClass('hide')
              .find('#colorPicker')
              .val(color);
          }
        });
      }

      if ($('#gradients').is(':checked')) {
        $('.sidebar-hero-edit .inner-gradients .gallery-image').each(
          function() {
            if ($(this).hasClass('active')) {
              from = $(this).attr('data-from');
              to = $(this).attr('data-to');
              $('.edit-gradient')
                .removeClass('hide')
                .find('#colorPickerFrom')
                .val(from)
                .find('#colorPickerTo')
                .val(to);
            }
          }
        );
      }
    }
  });

  $('.sidebar-hero-edit .sidebar-popup__save').on('click', function(e) {
    e.preventDefault();

    var type = null;
    var thumb_id = null;
    var color = null;
    var from = null;
    var to = null;

    $('.sidebar-hero-edit .tabs .tabs-title').each(function(i) {
      if ($(this).hasClass('is-active')) {
        if (i == 0) {
          type = 'image';

          $('.sidebar-hero-edit .ajaxHeroFilter .gallery-image').each(
            function() {
              if ($(this).hasClass('active')) {
                thumb_id = $(this).attr('data-id');
              }
            }
          );
        } else if (i == 1) {
          if ($('#solid').is(':checked')) {
            type = 'solid';

            $('.sidebar-hero-edit .inner-solid .gallery-image').each(
              function() {
                if ($(this).hasClass('active')) {
                  color = $(this).attr('data-color');
                  $('.edit-solid')
                    .removeClass('hide')
                    .find('#colorPicker')
                    .val(color);
                }
              }
            );
          }

          if ($('#gradients').is(':checked')) {
            type = 'gradient';

            $('.sidebar-hero-edit .inner-gradients .gallery-image').each(
              function() {
                if ($(this).hasClass('active')) {
                  from = $(this).attr('data-from');
                  to = $(this).attr('data-to');
                }
              }
            );
          }
        } else {
          type = 'image';
        }
      }
    });

    var wrap = $(this).closest('.sidebar-popup');
    var member_id = wrap.attr('data-member-id');
    //var custom_image = $('#my_file_upload_id').val ();

    var custom_image = $('#member_change_hero_image').prop('files')[0];

    var form_data = new FormData();
    form_data.append('file', custom_image);
    form_data.append('action', 'setHero');
    form_data.append('member_id', member_id);
    form_data.append('thumb_id', thumb_id);
    form_data.append('type', type);
    form_data.append('color', color);
    form_data.append('from', from);
    form_data.append('to', to);

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      dataType: 'text',
      cache: false,
      contentType: false,
      processData: false,
      data: form_data,
      type: 'post',
      success: function(response) {
        var url = window.location.href;
        window.location.replace(url);
      },
    });
  });

  $('.hero-delete').on('click', function(e) {
    e.preventDefault();

    var member_id = $(this).attr('data-member-id');

    var data = {
      action: 'deleteHero',
      member_id: member_id,
    };

    jQuery.post(myAjax.url, data, function(response) {
      console.log(response);
      var url = window.location.href;
      window.location.replace(url);
    });
  });

  $('.radio-nav').on('change', function() {
    if ($('#solid').is(':checked')) {
      $('.sidebar-hero-edit .inner-solid .gallery-image').each(function() {
        if ($(this).hasClass('active')) {
          var color = $(this).attr('data-color');
          $('.edit-solid')
            .find('#colorPicker')
            .val(color);
        }
      });
      $('.inner-solid').fadeIn();
      $('.edit-solid').toggleClass('hide');
      $('.inner-gradients').fadeOut();
      $('.edit-gradient').toggleClass('hide');
    }
    if ($('#gradients').is(':checked')) {
      $('.sidebar-hero-edit .inner-solid .gallery-image').each(function() {
        if ($(this).hasClass('active')) {
          var from = $(this).attr('data-from');
          var to = $(this).attr('data-to');
          $('.edit-gradient')
            .find('#colorPickerFrom')
            .val(from)
            .find('#colorPickerTo')
            .val(to);
        }
      });
      $('.inner-gradients').fadeIn();
      $('.edit-gradient').toggleClass('hide');
      $('.inner-solid').fadeOut();
      $('.edit-solid').toggleClass('hide');
    }
  });

  $('.inner-gradients .gallery-image').each(function() {
    var from = $(this).data('from');
    var to = $(this).data('to');

    $(this).css({
      background: 'linear-gradient(to bottom, ' + from + ', ' + to + ')',
    });
  });

  $('.inner-solid .gallery-image').each(function() {
    var color = $(this).data('color');

    $(this).css({
      'background-color': color,
    });
  });

  $(document).on('click', '.wrap-dropdown input', function() {
    $('.wrap-dropdown__list').slideDown(200);
  });

  $(document).on('click', '.wrap-dropdown__list .wrap-dropdown__item', function(
    e
  ) {
    e.preventDefault();

    var member = $(this).clone();
    $('.message-search__avatar').hide();
    $('.message-search__input').hide();
    $('.message-search').append(member);
    $(document)
      .find('.message-search > .wrap-dropdown__item .wrap-dropdown__item-name')
      .append('<i class="fas fa-minus-circle"></i>');
    $('.wrap-dropdown__list').slideUp(200);
  });

  $(document).on('click', '.message-search > .wrap-dropdown__item', function(
    e
  ) {
    e.preventDefault();
    $(this).remove();

    $('.message-search__avatar').show();
    $('.message-search__input').show();
  });

  $('.message-list .message-list__member:nth-child(1)').on('click', function(
    e
  ) {
    e.preventDefault();

    $(document)
      .find('.message-search > .wrap-dropdown__item')
      .remove();
    $('.message-search__avatar').hide();
    $('.message-search__input').hide();
    $('#chat1').fadeIn();
    $('#chat2').fadeOut();
    $('#member1').show();
    $('#member2').hide();
  });

  $('.message-list .message-list__member:nth-child(2)').on('click', function(
    e
  ) {
    e.preventDefault();

    $(document)
      .find('.message-search > .wrap-dropdown__item')
      .remove();
    $('.message-search__avatar').hide();
    $('.message-search__input').hide();
    $('#chat1').fadeOut();
    $('#chat2').fadeIn();
    $('#member1').hide();
    $('#member2').show();
  });

  $('.message-new a').on('click', function(e) {
    e.preventDefault();

    $(document)
      .find('.message-search > .wrap-dropdown__item')
      .remove();
    $('#chat1').fadeOut();
    $('#chat2').fadeOut();
    $('#member1').hide();
    $('#member2').hide();
    $('.message-search__avatar').show();
    $('.message-search__input').show();
  });

  $('.user-row a').on('click', function(e) {
    e.preventDefault();

    var $button = $(this);
    var oldValue = $button
      .parent()
      .find('input')
      .val();

    var newVal = null;
    if ($button.hasClass('plus')) {
      newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button
      .parent()
      .find('input')
      .val(newVal);
  });

  $('.btn-draft').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('hide');
    $('.action-status').toggleClass('hide');
  });

  var h_title = $('.single-product .product_title').outerHeight();
  $('.single-product .product-sidebar').css('padding-top', h_title + 'px');

  $('.files-row__item').on('click', function() {
    $('.files-row__item').removeClass('active');
    $(this).addClass('active');
  });


  //saving Product from Add Product page
  $(document).on('click', '#product_content_publish_button', function(e) {
    console.log('saving...');
    
  });

  $('.product-back').on('click', function(e) {
    e.preventDefault();

    var graphicDesign = getUrlParameter('graphicDesign');
    var files = getUrlParameter('files');
    var price = getUrlParameter('price');
    var desc = getUrlParameter('desc');
    var tags = getUrlParameter('tags');

    var url = $(this).attr('href');
    window.location.href =
      url +
      '?graphicDesign=' +
      graphicDesign +
      '&files=' +
      files +
      '&price=' +
      price +
      '&desc=' +
      desc +
      '&tags=' +
      tags;
  });

  $('.service-back').on('click', function(e) {
    e.preventDefault();

    var graphicDesign = getUrlParameter('graphicDesign');
    var price = getUrlParameter('price');
    var desc = getUrlParameter('desc');
    var timefrom = getUrlParameter('timefrom');
    var timeto = getUrlParameter('timeto');
    var hours = getUrlParameter('hours');
    var users = getUrlParameter('users');
    var tags = getUrlParameter('tags');

    var url = $(this).attr('href');
    window.location.href =
      url +
      '?graphicDesign=' +
      graphicDesign +
      '&price=' +
      price +
      '&desc=' +
      desc +
      '&timefrom=' +
      timefrom +
      '&timeto=' +
      timeto +
      '&hours=' +
      hours +
      '&users=' +
      users +
      '&tags=' +
      tags;
  });

  $(document).on('click', '.add_contributor', function() {
    var $this = $(this);
    var click = $this.attr('data-click');

    $('#add_contributor .contributor, .accordion-content .contributor').each(
      function(i) {
        if (i == click) {
          $(this).removeClass('hide');
        }
      }
    );

    click++;
    $this.attr('data-click', click);
  });

  $('#styleColor').on('change', function() {
    var val = $(this).val();
    console.log(val);
    if (val == 'black') {
      $('.portfolio-content .portfolio-content__txt').each(function() {
        $(this).css('background-color', val);
        $(this)
          .find('p')
          .css('color', '#eb0000');
      });
    } else if (val == 'orange') {
      $('.portfolio-content .portfolio-content__txt').each(function() {
        $(this).css('background-color', val);
        $(this)
          .find('p')
          .css('color', 'white');
      });
    } else if (val == 'blue') {
      $('.portfolio-content .portfolio-content__txt').each(function() {
        $(this).css('background-color', val);
        $(this)
          .find('p')
          .css('color', 'white');
      });
    } else if (val == 'yellow') {
      $('.portfolio-content .portfolio-content__txt').each(function() {
        $(this).css('background-color', val);
        $(this)
          .find('p')
          .css('color', '#000');
      });
    }
  });

  $('.range').on('change', function() {
    var space_val = $(this).val();
    $('.portfolio-content div').each(function() {
      $(this).css('margin-bottom', space_val + 'px');
    });
  });

  var wysiwyg_counter = 0;
  function loadTiny(field) {
    /* eslint-disable */
    tinymce.init({
      selector: 'textarea#' + field,
      height: 500,
      menubar: false,
      toolbar: [
        'undo redo styleselect bold italic bullist numlist outdent indent link charmap hr blockquote image',
      ],
      max_chars: 1200,
      plugins: 'lists media image link paste',
      paste_as_text: true,
      content_style:
        'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      body_class: 'tinyMCE',
      image_title: true,
      automatic_uploads: true,
      file_picker_types: 'image',
      file_picker_callback: function(cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.setAttribute('id', 'wysiwyg_content_images' + wysiwyg_counter);
        input.setAttribute('name', 'wysiwyg_content_images' + wysiwyg_counter);
        wysiwyg_counter++;
        var form = document.getElementById('blog_content_form');
        form.appendChild(input);
        input.onchange = function() {
          var file = this.files[0];
          var reader = new FileReader();
          reader.onload = function() {
            // Note: Now we need to register the blob in TinyMCEs image blob
            // registry. In the next release this part hopefully won't be
            // necessary, as we are looking to handle it internally.
            var id = 'blobid' + new Date().getTime();
            var blobCache = tinymce.activeEditor.editorUpload.blobCache;
            var base64 = reader.result.split(',')[1];
            var blobInfo = blobCache.create(id, file, base64);
            blobCache.add(blobInfo);

            // call the callback and populate the Title field with the file name
            cb(blobInfo.blobUri(), { title: file.name });
          };
          reader.readAsDataURL(file);
        };

        input.click();
      },
    });
    /* eslint-enable */
  }

  /* wysiwyg counter */
  var addElement = 0;
  var addFileElement = 0;
  var addAnchorElement = 0;
  var addTitleElement = 0;

  $('.content-section.add-ds-portfolio a').on('click', function(e) {
    e.preventDefault();

    $('.portfolio-content__preview').addClass('hide');
    $('.portfolio-content__widget').removeClass('hide');

    var wrap = $('.build-content');
    var template_txt = $('.append-content .portfolio-content__txt').clone();
    var template_img = $('.append-content .portfolio-content__image').clone();
    var template_gallery = $(
      '.append-content .portfolio-content__gallery'
    ).clone();
    var template_anchor = $(
      '.append-content .portfolio-content__anchor'
    ).clone();
    var template_title = $('.append-content .portfolio-content__title').clone();

    if ($(this).hasClass('link-text')) {
      var idField = 'wysiwyg_textarea' + addElement;
      $('.wysiwyg-textarea', template_txt)
        .attr('name', idField)
        .attr('id', idField);
      /* eslint-disable */
      $('img', template_txt)
        .attr('src', '/wp-content/uploads/2021/04/drag.jpg')
        .addClass('lazyloaded');
      /* eslint-enable */
      wrap.append(template_txt);
      addElement++;
      loadTiny(idField);
    } else if ($(this).hasClass('link-image')) {
      var idFile = 'add-portfolio__input' + addFileElement;
      $('.add-portfolio__input', template_img)
        .attr('name', idFile)
        .attr('id', idFile);
      var idFileHidden = 'image_update_add-portfolio__input' + addFileElement;
      $('.image_update_add-portfolio__input', template_img)
        .attr('name', idFileHidden)
        .attr('id', idFileHidden);
      /* eslint-disable */
      $('img', template_img)
        .attr('src', '/wp-content/uploads/2021/04/drag.jpg')
        .addClass('lazyloaded');
      /* eslint-enable */
      wrap.append(template_img);
      addFileElement++;
    } else if ($(this).hasClass('link-anchor')) {
      var idAnchor = 'add-portfolio__anchor' + addAnchorElement;
      $('.add-portfolio__anchor', template_anchor)
        .attr('name', idAnchor)
        .attr('id', idAnchor);
      wrap.append(template_anchor);
      addAnchorElement++;
    } else if ($(this).hasClass('link-title')) {
      var idTitle = 'add-portfolio__title' + addTitleElement;
      $('.add-portfolio__title', template_title)
        .attr('name', idTitle)
        .attr('id', idTitle);
      wrap.append(template_title);
      addTitleElement++;
    } else if ($(this).hasClass('link-gallery')) {
      //console.log('click on gallery 2');
      // var idFile = 'add-portfolio-gallery__input' + addFileElement;
      // $('.add-portfolio-gallery__input', template_gallery)
      //   .attr('name', idFile)
      //   .attr('id', idFile);
      // var idFileHidden = 'gallery_update_add-portfolio__input' + addFileElement;
      // $('.gallery_update_add-portfolio__input', template_gallery)
      //   .attr('name', idFileHidden)
      //   .attr('id', idFileHidden);
      // /* eslint-disable */
      // $('img', template_gallery)
      //   .attr('src', '/wp-content/uploads/2021/04/drag.jpg')
      //   .addClass('lazyloaded');
      // wrap.append(template_gallery);
      // addFileElement++;
    }
  });

  $('.content-section.blog a').on('click', function(e) {
    e.preventDefault();

    $('.blog-content__preview').addClass('hide');
    $('.blog-content__widget').removeClass('hide');

    var wrap = $('.build-content');
    var template_txt = $('.append-content .blog-content__txt').clone();
    var template_img = $('.append-content .blog-content__image').clone();
    var template_anchor = $('.append-content .blog-content__anchor').clone();
    var template_title = $('.append-content .blog-content__title').clone();

    if ($(this).hasClass('link-text')) {
      var idField = 'wysiwyg_textarea' + addElement;
      $('.wysiwyg-textarea', template_txt)
        .attr('name', idField)
        .attr('id', idField);
      /* eslint-disable */
      $('img', template_txt)
        .attr('src', '/wp-content/uploads/2021/04/drag.jpg')
        .addClass('lazyloaded');
      /* eslint-enable */
      wrap.append(template_txt);
      addElement++;
      loadTiny(idField);
    } else if ($(this).hasClass('link-image')) {
      var idFile = 'add-blog__input' + addFileElement;
      $('.add-blog__input', template_img)
        .attr('name', idFile)
        .attr('id', idFile);
      var idFileHidden = 'image_update_add-blog__input' + addFileElement;
      $('.image_update_add-blog__input', template_img)
        .attr('name', idFileHidden)
        .attr('id', idFileHidden);
      /* eslint-disable */
      $('img', template_img)
        .attr('src', '/wp-content/uploads/2021/04/drag.jpg')
        .addClass('lazyloaded');
      /* eslint-enable */
      wrap.append(template_img);
      addFileElement++;
    } else if ($(this).hasClass('link-anchor')) {
      var idAnchor = 'add-blog__anchor' + addAnchorElement;
      $('.add-blog__anchor', template_anchor)
        .attr('name', idAnchor)
        .attr('id', idAnchor);
      wrap.append(template_anchor);
      addAnchorElement++;
    } else if ($(this).hasClass('link-title')) {
      var idTitle = 'add-blog__title' + addTitleElement;
      $('.add-blog__title', template_title)
        .attr('name', idTitle)
        .attr('id', idTitle);
      wrap.append(template_title);
      addTitleElement++;
    }
  });
  /* eslint-disable */
  $('.blog-content .build-content .blog-content__txt textarea').each(
    function() {
      var idField = $(this).prop('id');
      loadTiny(idField);
    }
  );
  $('.portfolio-content .build-content .portfolio-content__txt textarea').each(
    function() {
      var idField = $(this).prop('id');
      loadTiny(idField);
    }
  );
  var widget_row = 0;
  $('.blog-content .build-content .section-build').each(function() {
    widget_row = $(this).data('row');
  });
  $('.portfolio-content .build-content .section-build').each(function() {
    widget_row = $(this).data('row');
  });
  addElement = widget_row + 1;
  addFileElement = widget_row + 1;
  addAnchorElement = widget_row + 1;
  addTitleElement = widget_row + 1;
  /* eslint-enable */
  $('.build-content').sortable({
    handle: '.move-section',
    /* eslint-disable */
    start: function(e, ui) {
      $(ui.item)
        .find('textarea')
        .each(function() {
          tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
        });
    },
    stop: function(e, ui) {
      $(ui.item)
        .find('textarea')
        .each(function() {
          tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
        });
    },
    /* eslint-enable */
  });

  $(document).on('click', '.remove-section', function(e) {
    e.preventDefault();

    $(this)
      .closest('.section-build')
      .remove();
  });

  $('.preview-portfolio-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    // fade: true,
    asNavFor: '.preview-portfolio-nav',
    prevArrow: '<i class="fas fa-angle-left arrow-left"></i>',
    nextArrow: '<i class="fas fa-angle-right arrow-right"></i>',
  });
  $('.preview-portfolio-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: '.preview-portfolio-for',
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
  });

  function rangeInputChangeEventHandler() {
    var minBtn = $(this)
        .parent()
        .children('.min'),
      maxBtn = $(this)
        .parent()
        .children('.max'),
      range_min = $(this)
        .closest('.gradient-color')
        .find('.range_min'),
      range_max = $(this)
        .closest('.gradient-color')
        .find('.range_max'),
      minVal = parseInt($(minBtn).val()),
      maxVal = parseInt($(maxBtn).val()),
      origin = $(this).context.className;

    if (origin === 'min' && minVal > maxVal - 5) {
      $(minBtn).val(maxVal - 5);
    }
    var minVal2 = parseInt($(minBtn).val());
    var minColor = null;

    if (minVal2 >= 0 && minVal2 < 17) {
      minColor = '#ff9710';
    } else if (minVal2 >= 17 && minVal2 < 33) {
      minColor = '#fff715';
    } else if (minVal2 >= 33 && minVal2 < 50) {
      minColor = '#49ff3c';
    } else if (minVal2 >= 50 && minVal2 < 66) {
      minColor = '#6cffeb';
    } else if (minVal2 >= 66 && minVal2 < 83) {
      minColor = '#cd00ff';
    } else if (minVal2 >= 83 && minVal2 < 100) {
      minColor = '#f00';
    }
    range_min.val(minColor);

    if (origin === 'max' && maxVal - 5 < minVal2) {
      $(maxBtn).val(5 + minVal2);
    }
    var maxVal2 = parseInt($(maxBtn).val());
    var maxColor = null;

    if (maxVal2 > 0 && maxVal2 < 17) {
      maxColor = '#ff9710';
    } else if (maxVal2 >= 17 && maxVal2 < 33) {
      maxColor = '#fff715';
    } else if (maxVal2 >= 33 && maxVal2 < 50) {
      maxColor = '#49ff3c';
    } else if (maxVal2 >= 50 && maxVal2 < 66) {
      maxColor = '#6cffeb';
    } else if (maxVal2 >= 66 && maxVal2 < 83) {
      maxColor = '#cd00ff';
    } else if (maxVal2 >= 83 && maxVal2 <= 100) {
      maxColor = '#f00';
    }
    range_max.val(maxColor);
  }

  $('input[type="range"]').on('input', rangeInputChangeEventHandler);

  $('#orders-tabs .tabs-title a').on('click', function() {
    $('.manage-orders__top .count-orders').html(
      `You Have <b>XX</b> ${$(this).text()}`
    );
  });

  $('#content-curation-tabs .tabs-title a').on('click', function() {
    $('.count-orders__counter').html($(this).data('counter'));
  });

  $('#member-curation-tabs .tabs-title a').on('click', function() {
    var tab = $(this).data('tab');
    var count = $('#' + tab + ' .store-items').data('counter');
    $('.count-orders__counter').html(count);
  });

  $('.message-connect__close, .message-connect__save').on('click', function(e) {
    e.preventDefault();
    $(this)
      .closest('.message-connect')
      .fadeOut();
  });

  $('#dashboard-connect').on('click', '.toggle-message', function() {
    $(this)
      .toggleClass('active')
      .closest('.connect__item')
      .find('.connect__message')
      .slideToggle();
  });

  let currStep = 0;
  let quoteSteps = $('.custom-quote__wrap .step');

  $('#custom-quote').on('click', function(e) {
    e.preventDefault();
    $('.custom-quote__wrap').fadeIn();
  });

  $('.custom-quote__wrap').on('click', '.custom-quote__next', function(e) {
    e.preventDefault();
    $(quoteSteps[currStep]).hide();
    $(quoteSteps[++currStep]).fadeIn();
  });

  $('.custom-quote__wrap').on('click', '.custom-quote__back', function(e) {
    e.preventDefault();
    $(quoteSteps[currStep]).hide();
    $(quoteSteps[--currStep]).fadeIn();
  });

  $('.custom-quote__wrap').on('click', '.custom-quote__submit', function(e) {
    e.preventDefault();
    $(quoteSteps[currStep]).hide();
    $(quoteSteps[++currStep]).fadeIn();
  });

  $('.custom-quote__wrap').on(
    'click',
    '.custom-quote__cancel, .custom-quote__close',
    function(e) {
      e.preventDefault();
      $('.custom-quote__wrap').fadeOut();
    }
  );
  jQuery(document).ajaxComplete(function() {
    $('form.woocommerce-cart-form')
      .off('click', '.quantity-plus, .quantity-minus')
      .on('click', '.quantity-plus, .quantity-minus', function() {
        // Get current quantity values
        let qty = $(this)
          .closest('.cart-item__quantity')
          .find('input.qty');
        let val = parseFloat(qty.val());
        let max = parseFloat(qty.attr('max'));
        let min = parseFloat(qty.attr('min'));
        let step = parseFloat(qty.attr('step'));
        step = 'undefined' !== typeof step ? parseInt(step) : 1;

        // Change the value if plus or minus
        if ($(this).is('.quantity-plus')) {
          if (max && max <= val) {
            qty.val(max);
          } else {
            qty.val(val + step);
          }
        } else {
          if (min && min >= val) {
            qty.val(min);
          } else if (val > 1) {
            qty.val(val - step);
          }
        }
        qty.trigger('change');
      });
  });

  $('.woocommerce-cart').on('change', 'input.qty', function() {
    if ($(this).val() != '') {
      $("[name='update_cart']")
        .prop('disabled', false)
        .trigger('click');
    }
  });

  if (window.innerWidth < 1024) {
    var term_slider_m = $('.term-posts');
    initTermSliderM(term_slider_m);
  }

  $('.product-info__rating span').click(function() {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('.reviews_tab').offset().top,
      },
      500
    );
    $('ul.tabs.wc-tabs > li.active').removeClass('active');
    $('div.wc-tab').hide();
    $('ul.tabs.wc-tabs > li.reviews_tab').addClass('active');
    $('div#tab-reviews').show();
  });
});

const allRanges = document.querySelectorAll('.range-wrap');
allRanges.forEach(wrap => {
  const range = wrap.querySelector('.range');
  const bubble = wrap.querySelector('.space-value');

  range.addEventListener('input', () => {
    setBubble(range, bubble);
  });
  setBubble(range, bubble);
});

function setBubble(range, bubble) {
  const val = range.value;
  bubble.value = val;

  // Sorta magic numbers based on size of the native UI thumb
  // bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
}

if ($('.range').length) {
  document.querySelector('.range').oninput = function() {
    this.style.background = '#EF6D1C';
  };
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

// document.querySelectorAll('input[type=color]').forEach(function(picker) {
//   var targetLabel = document.querySelector('label[for="' + picker.id + '"]'),
//     codeArea = document.createElement('span');
//   //
//   codeArea.innerHTML = picker.value;
//   targetLabel.appendChild(codeArea);
//
//   picker.addEventListener('change', function() {
//     codeArea.innerHTML = picker.value;
//     targetLabel.appendChild(codeArea);
//   });
// });

/* eslint-disable */
function tinymce_updateCharCounter(el, len) {
  $('#' + el.id)
    .prev()
    .find('.char_count')
    .text(len + '/' + el.settings.max_chars);
}

function tinymce_getContentLength() {
  return tinymce.get(tinymce.activeEditor.id).contentDocument.body.innerText
    .length;
}

function tinymce_getContentLengthProduct() {
  return (
    tinymce.get(tinymce.activeEditor.id).contentDocument.body.innerText.length -
    1
  );
}

/* eslint-enable */

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here

  // show the login form with the error message after failed login
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get('login');
  if (c == 'failed') {
    $('.header-icon--person').trigger('click');
  }

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  var desc = getUrlParameter('desc');
  if (
    $('.add-product-sidebar').hasClass('add__product') ||
    $('.add-product-sidebar').hasClass('add__service')
  ) {
    /* eslint-disable */
    tinymce.get('add-product-desc').setContent(desc);
    /* eslint-enable */
  }
  /* eslint-disable */
  if (
    $('body').hasClass('.page-template-template-add-service') ||
    $('body').hasClass('.page-template-template-add-product')
  ) {
    if (tinymce.get('product-tab-area').getContent() == '') {
      tinymce
        .get('product-tab-area')
        .setContent(
          "<p id='imThePlaceholder'>An optional long description for your item can go here.</p>"
        );
    }
  }
  /* eslint-enable */
  //Focus for Inputs on Registration page
  $('.form-effect-wrap input, select').focusout(function() {
    if ($(this).val() != '') {
      $(this).addClass('has-content');
    } else {
      $(this).removeClass('has-content');
    }
  });

  if ($(window).width() < 1024) {
    var gallery_product = $('.flex-viewport').height();
    $('.flex-control-nav .slick-arrow').css(
      'top',
      '-' + gallery_product / 2 + 'px'
    );

    $('.wc-tabs-wrapper .panel').each(function(i) {
      console.log($(this));
      var clone = $(this).clone();
      $(this).remove();
      var index = i + 1;
      $('.wc-tabs-wrapper li:nth-of-type(' + index + ')')
        .after(clone)
        .removeClass('active');
    });

    var services_slider_product = $('.author-services .store-items');
    services_slider_product.slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      arrows: false,
      dots: true,
    });
  }

  if ($('#btnCopy').length) {
    document.getElementById('btnCopy').addEventListener('click', function() {
      copyToClipboard(document.getElementById('copyLink'));
    });
  }

  // if ($('.compare-content__wrapper').length) {
  //   var header_h = $('.compare-hero').outerHeight();
  //
  //   $('.compare-content').css('marginTop', header_h + 'px');
  // }
});

function initTermSliderM(term_slider_m) {
  term_slider_m.slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    arrows: false,
    dots: true,
  });
}

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // Init shop page sliders on the tablet and smaller
  var term_slider_m = $('.term-posts');
  if (window.innerWidth < 1024) {
    if (!term_slider_m.hasClass('slick-initialized')) {
      initTermSliderM(term_slider_m);
    }
  } else {
    if (term_slider_m.hasClass('slick-initialized')) {
      term_slider_m.slick('unslick');
    }
  }

  if ($(window).width() < 1024) {
    var gallery_product = $('.flex-viewport').height();
    $('.flex-control-nav .slick-arrow').css(
      'top',
      '-' + gallery_product / 2 + 'px'
    );
  }

  resizeVideo();
  $(document)
    .find('.nwk__item')
    .each(function() {
      var width = $(this).width();
      $(this).height(width);
    });

    alignCloseBtn ();
    //setTimeout(alignCloseBtn, 500);
});

function alignCloseBtn() {

      var visiblePopup = $('.sidebar-popup:visible'),
    visiblePopupClose = visiblePopup.find('.popup-close'),
    visiblePopupWrap = visiblePopup.find('.sidebar-popup__wrapper');

    var offset = visiblePopupWrap.position();
    if (!offset)
        return;
         
    var top = offset.top;
    var p_left = offset.left;
    var width = visiblePopupWrap.width();
    
    visiblePopupWrap
      .prev('.popup-close')
      .css('left', p_left + width - 25 + 'px')
      .css('top', top - 25 + 'px');

      jQuery('.popup-close').show ();


//   var visiblePopup = $('.sidebar-popup:visible'),
//     visiblePopupClose = visiblePopup.find('.popup-close'),
//     visiblePopupWrap = visiblePopup.find('.sidebar-popup__wrapper');

//   if (
//     visiblePopup.length &&
//     visiblePopupClose.length &&
//     visiblePopupWrap.length
//   ) {
//     var offset = visiblePopupWrap.position();
//     var top = offset.top;
//     console.log(top);
//     var p_left = offset.left;
//     var width = visiblePopupWrap.width();
//     console.log(top);
//     visiblePopupWrap
//       .prev('.popup-close')
//       .css('left', p_left + width - 33 + 'px')
//       .css('top', top - 56 + 20 + 'px');
//   }
}

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code goes here

  if ($('.single-blog__content').length) {
    let scroll_top = $('.single-blog__content').offset().top;
    let scroll_bottom =
      scroll_top + $('.single-blog__content').height() - $('.sidebar').height();

    if (
      $(document).scrollTop() > scroll_top &&
      $(document).scrollTop() < scroll_bottom
    ) {
      //$('.sidebar').addClass('fixed');
    } else {
      //$('.sidebar').removeClass('fixed');
    }
  }

  if ($('.single-kb__content').length) {
    let scroll_top = $('.single-kb__content').offset().top;
    let scroll_bottom =
      scroll_top +
      $('.single-kb__content').height() -
      $('.single-kb__sidebar').height();

    if (
      $(document).scrollTop() > scroll_top &&
      $(document).scrollTop() < scroll_bottom
    ) {
      //$('.single-kb__sidebar').addClass('fixed');
    } else {
      //$('.single-kb__sidebar').removeClass('fixed');
    }
  }

  // if ($('.compare-content__wrapper').length) {
  //   var body_h = $(document).scrollTop();
  //   var header_h = $('.compare-hero').outerHeight();
  //   var start_scroll = $('.wrapper-featured').offset().top;
  //
  //   $('.compare-content').css('marginTop', header_h + 'px');
  //
  //   if (start_scroll <= body_h) {
  //     $('.others-slide__header, .primary-slide__header').css(
  //       'top',
  //       body_h - header_h + 324 + 'px'
  //     );
  //   }
  // }
});

function copyToClipboard(elem) {
  // create hidden text element, if it doesn't already exist
  var targetId = '_hiddenCopyText_';
  var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
  var origSelectionStart, origSelectionEnd;
  if (isInput) {
    // can just use the original source element for the selection and copy
    target = elem;
    origSelectionStart = elem.selectionStart;
    origSelectionEnd = elem.selectionEnd;
  } else {
    // must use a temporary form element for the selection and copy
    target = document.getElementById(targetId);
    if (!target) {
      var target = document.createElement('textarea');
      target.style.position = 'absolute';
      target.style.left = '-9999px';
      target.style.top = '0';
      target.id = targetId;
      document.body.appendChild(target);
    }
    target.textContent = elem.textContent;
  }
  // select the content
  var currentFocus = document.activeElement;
  target.focus();
  target.setSelectionRange(0, target.value.length);

  // copy the selection
  var succeed;
  try {
    succeed = document.execCommand('copy');
  } catch (e) {
    succeed = false;
  }
  // restore original focus
  if (currentFocus && typeof currentFocus.focus === 'function') {
    currentFocus.focus();
  }

  if (isInput) {
    // restore prior selection
    elem.setSelectionRange(origSelectionStart, origSelectionEnd);
  } else {
    // clear temporary content
    target.textContent = '';
  }
  return succeed;
}

let $body = $('body');

$body.on('click', '.show-sub, .show-sub-item', function() {
  $(this)
    .closest('.menu-item')
    .addClass('open');
  console.log('open');
});

$body.on('click', '.hide-sub, .hide-sub-item', function() {
  $(this)
    .closest('.open')
    .removeClass('open');
  // console.log($(this).html());
  console.log('slose');
});

  $(document).ready (function () {
    $('.popup-banner-button-1').click (function () {
        var id = $(this).attr ('id');
        
        jQuery('.popup-close').hide ();
        jQuery('#popup-banner-modal-1_'+id).fadeIn(function () {
            alignCloseBtn ();
        });
        alignCloseBtn ();
    });

    $('.popup-banner-button-2').click (function () {
        var id = $(this).attr ('id');

        jQuery('.popup-close').hide ();
        $('#popup-banner-modal-2_'+id).fadeIn(function () {
            alignCloseBtn ();
        });
        alignCloseBtn ();
    });
});